/* eslint-disable max-len */
/**
 * @typedef {keyof Translations} TranslationsType
 */
/**
 * @typedef {{"en": string, "fr" :string, "nl": string, "es": string}} TranslationsObjectType
 */
/**
 * @typedef {keyof Translations["default"]} LangsType
 */

export const Langs = ['en', 'fr', 'es', 'nl']

export const Translations = {
    appName: {
        en: 'Client Portal',
        fr: 'Portail client',
        nl: 'Klantenportaal',
        es: 'Portal del cliente',
    },
    'transport.errors.noPacketFound': {
        en: 'No packet found for transport(s) N°: {{transportNumbers}}',
        fr: 'Aucun colis trouvé pour le ou les transport(s) N° : {{transportNumbers}}',
        nl: 'Geen pakket gevonden voor transport(en) N°: {{transportNumbers}}',
        es: 'No se encontró ningún paquete para el transporte(s) N°: {{transportNumbers}}',
    },
    'transport.errors.labelBarcodeMissing': {
        en: 'Transport label barcode is missing - Transport(s): {{transportNumbers}}',
        fr: "Le code-barres de l'etiquette transport est manquant - Transport(s) : {{transportNumbers}}",
        nl: 'Barcode van transportlabel ontbreekt - Transport(en): {{transportNumbers}}',
        es: 'Falta el codigo de barras de la etiqueta de transporte - Transporte(s): {{transportNumbers}}',
    },
    'transport.errors.labelBarcodeGenerationFailed': {
        en: 'Transport label barcode generation failed - Transport(s): {{transportNumbers}}',
        fr: "La generation du code-barres de l'etiquette transport a echoue - Transport(s) : {{transportNumbers}}",
        nl: 'Genereren van barcode voor transportlabel is mislukt - Transport(en): {{transportNumbers}}',
        es: 'Error al generar el codigo de barras de la etiqueta de transporte - Transporte(s): {{transportNumbers}}',
    },
    articleName: {
        en: 'Article name',
        fr: "Nom de l'article",
        nl: 'Artikelnaam',
        es: 'Nombre del artículo',
    },
    addManualArticle: {
        fr: 'Renseigner un nouvel article manuellement',
        en: 'Add a new article manually',
        nl: 'Voeg een nieuw artikel handmatig toe',
        es: 'Agregar un nuevo artículo manualmente',
    },
    cancelManualArticle: {
        fr: 'Annuler la saisie manuelle',
        en: 'Cancel manual entry',
        nl: 'Annuleer handmatige invoer',
        es: 'Cancelar entrada manual',
    },
    printLoadingSheet: {
        en: 'Print loading sheet',
        fr: 'Imprimer feuille de chargement',
        nl: 'Laadblad afdrukken',
        es: 'Imprimir hoja de carga',
    },
    seller: {
        en: 'Seller',
        fr: 'Vendeur',
        nl: 'Verkoper',
        es: 'Vendedor',
    },
    sellerTooltipMessage: {
        en: 'Here you can enter the name you want to appear to your client when proposing an appointment.',
        fr: 'Vous pouvez renseigner ici le nom que vous souhaitez faire apparaître à votre client lors de la proposition de rendez-vous',
        nl: 'U kunt hier de naam invoeren die u aan uw klant wilt laten verschijnen bij het voorstellen van een afspraak',
        es: 'Aquí puede ingresar el nombre que desea que aparezca para su cliente al proponer una cita',
    },
    refuse: {
        en: 'Refuse',
        fr: 'Refuser',
        nl: 'Weigeren',
        es: 'Rechazar',
    },
    export: {
        en: 'Export',
        fr: 'Exporter',
        nl: 'Exporteren',
        es: 'Exportar',
    },
    accessibility: {
        en: 'Accessibility',
        fr: 'Accessibilité',
        nl: 'Toegankelijkheid',
        es: 'Accesibilidad',
    },
    accessibilityTooltip: {
        en: 'Please note: difficult access will result in a surcharge when invoicing for the service.',
        fr: 'Attention : un accès difficile entrainera un supplément lors de la facturation de la prestation.',
        nl: 'Let op: moeilijke toegang zal resulteren in een toeslag bij de facturatie van de dienst.',
        es: 'Por favor, note que el acceso difícil resultará en un recargo al facturar el servicio.',
    },
    accessibilities: {
        en: 'Accessibilities',
        fr: 'Accessibilités',
        nl: 'Toegankelijkheid',
        es: 'Accesibilidades',
    },
    chooseDeliveryType: {
        en: 'Choose delivery type',
        fr: 'Choisissez le type de livraison',
        nl: 'Kies het type levering',
        es: 'Elegir tipo de entrega',
    },
    ladDeliveryTypeDateMessage: {
        en: 'The appointment date will be made directly by the recipient via our appointment booking module.',
        fr: 'La date de rendez-vous sera prise directement par le destinataire via notre module de prise de RDV.',
        nl: 'De afspraakdatum wordt rechtstreeks door de ontvanger vastgelegd via onze afspraakboekingsmodule.',
        es: 'La fecha de la cita será realizada directamente por el destinatario a través de nuestro módulo de reserva de citas.',
    },
    stocks: {
        en: 'Stocks',
        fr: 'Stocks',
        nl: 'Voorraden',
        es: 'Existencias',
    },
    useStocks: {
        en: 'Can the customer see their inventory?',
        fr: 'Le client peut-il voir ses stocks ?',
        nl: 'Kan de klant zijn voorraad zien?',
        es: '¿El cliente puede ver su inventario?',
    },
    useQuotes: {
        fr: 'Le client peut-il créer un devis ?',
        en: 'Can the customer create a quote?',
        nl: 'Kan de klant een offerte maken?',
        es: '¿El cliente puede crear una cotización?',
    },
    useCompanies: {
        en: 'Can the customer see their company information?',
        fr: 'Le client peut-il voir les informations de sa société ?',
        nl: 'Kan de klant de informatie van zijn bedrijf zien?',
        es: '¿El cliente puede ver la información de su empresa?',
    },
    containerCode: {
        en: 'Container code',
        fr: 'Code conteneur',
        nl: 'Containercode',
        es: 'Código del contenedor',
    },
    recovery: {
        en: 'Recovery',
        fr: 'Reprise',
        nl: 'Herstel',
        es: 'Recuperación',
    },
    redelivery: {
        en: 'Redelivery',
        fr: 'Re-livraison',
        nl: 'Herbezorging',
        es: 'Reentrega',
    },
    orderType: {
        en: 'Order type',
        fr: 'Type de commande',
        nl: 'Besteltype',
        es: 'Tipo de pedido',
    },
    vehicleEquipment: {
        en: 'Vehicle equipment',
        fr: 'Equipement du véhicule',
        nl: 'Voertuiguitrusting',
        es: 'Equipamiento del vehículo',
    },
    vehicleEquipmentItems: {
        en: 'Vehicle equipment items',
        fr: 'Équipements du véhicule',
        nl: 'Voertuiguitrusting',
        es: 'Equipamientos del vehículo',
    },
    modalEditVehicleEquipmentTitle: {
        en: 'Edit vehicle equipment',
        fr: "Modifier l'équipement du véhicule",
        nl: 'Voertuiguitrusting bewerken',
        es: 'Editar equipamiento del vehículo',
    },
    modalVehicleEquipmentTitle: {
        en: 'Add vehicle equipment',
        fr: 'Ajouter un équipement du véhicule',
        nl: 'Voertuiguitrusting toevoegen',
        es: 'Agregar equipamiento del vehículo',
    },
    removeVehicleEquipment: {
        en: 'Remove vehicle equipment',
        fr: "Supprimer l'équipement du véhicule",
        nl: 'Voertuiguitrusting verwijderen',
        es: 'Eliminar equipamiento del vehículo',
    },
    sureRemoveVehicleEquipment: {
        en: 'Are you sure you want to remove vehicle equipment? This action is final.',
        fr: "Êtes-vous certain de vouloir supprimer l'équipement du véhicule ? Cette action est définitive.",
        nl: 'Weet u zeker dat u de voertuiguitrusting wilt verwijderen? Deze actie is definitief.',
        es: '¿Está seguro de que desea eliminar el equipamiento del vehículo? Esta acción es definitiva.',
    },
    default: {
        en: 'default',
        fr: 'défaut',
        nl: 'standaard',
        es: 'predeterminado',
    },
    isDefault: {
        en: 'is default ?',
        fr: 'est par défaut ?',
        nl: 'is standaard ?',
        es: '¿es el predeterminado?',
    },
    description: {
        en: 'description',
        fr: 'description',
        nl: 'beschrijving',
        es: 'descripción',
    },
    login: {
        en: 'Login',
        fr: 'Connexion',
        nl: 'Inloggen',
        es: 'Iniciar sesión',
    },
    loadingStartWindow: {
        en: 'Loading start window',
        fr: 'Horaire début de chargement',
        nl: 'Laadstartvenster',
        es: 'Ventana de inicio de carga',
    },
    loadingEndWindow: {
        en: 'Loading end window',
        fr: 'Horaire fin de chargement',
        nl: 'Laadeindvenster',
        es: 'Ventana de finalización de carga',
    },
    departmentNotAllowed: {
        en: 'Your address is not supported by our shipping plan. Please contact {{companyName}} sales department to place your order: {{email}}',
        fr: "Votre adresse n'est pas prise en charge par notre plan de transport. Merci de contacter le service commercial {{companyName}} pour réaliser votre commande : {{email}}",
        nl: 'Uw adres wordt niet ondersteund door ons transportplan. Neem contact op met de verkoopafdeling van {{companyName}} om uw bestelling te plaatsen: {{email}}',
        es: 'Su dirección no está soportada por nuestro plan de envío. Por favor, contacte con el departamento de ventas de {{companyName}} para realizar su pedido: {{email}}',
    },
    deliveryStartWindow: {
        en: 'Delivery start window',
        fr: 'Créneau début de livraison',
        nl: 'Leveringsstartvenster',
        es: 'Ventana de inicio de entrega',
    },
    deliveryEndWindow: {
        en: 'Delivery end window',
        fr: 'Créneau fin de livraison',
        nl: 'Leveringseindvenster',
        es: 'Ventana de finalización de entrega',
    },
    deliveryTime: {
        en: 'Delivery time',
        fr: 'délai de livraison',
        nl: 'levertijd',
        es: 'Tiempo de entrega',
    },
    deliveryTimes: {
        en: 'Delivery times',
        fr: 'délais de livraison',
        nl: 'levertijden',
        es: 'Tiempos de entrega',
    },
    deliveryTimeUnit: {
        en: 'D+{{deliveryTime}}',
        fr: 'J+{{deliveryTime}}',
        nl: 'D+{{deliveryTime}}',
        es: 'D+{{deliveryTime}}',
    },
    deliveryMorning: {
        en: 'Delivery planned on {{date}} between 08:00 and 13:00',
        fr: 'Livraison Planifiée le {{date}} entre 08:00 et 13:00',
        nl: 'Levering gepland op {{date}} tussen 08:00 en 13:00',
        es: 'Entrega planificada el {{date}} entre 08:00 y 13:00',
    },
    deliveryAfternoon: {
        en: 'Delivery planned on {{date}} between 13:00 and 18:00',
        fr: 'Livraison Planifiée le {{date}} entre 13:00 et 18:00',
        nl: 'Levering gepland op {{date}} tussen 13:00 en 18:00',
        es: 'Entrega planificada el {{date}} entre 13:00 y 18:00',
    },
    planned: {
        en: 'Planned',
        fr: 'Planifié',
        nl: 'Gepland',
        es: 'Planificado',
    },
    home: {
        en: 'Home',
        fr: 'Accueil',
        nl: 'Startpagina',
        es: 'Inicio',
    },
    title: {
        en: 'Title',
        fr: 'Titre',
        nl: 'Titel',
        es: 'Título',
    },
    actualityDescription: {
        en: 'Actuality description',
        fr: "Description de l'actualité",
        nl: 'Actualiteitsbeschrijving',
        es: 'Descripción de la actualidad',
    },
    cancel: {
        en: 'Cancel',
        fr: 'Annuler',
        nl: 'Annuleren',
        es: 'Cancelar',
    },
    save: {
        en: 'Save',
        fr: 'Enregistrer',
        nl: 'Opslaan',
        es: 'Guardar',
    },
    saveOrder: {
        en: 'Save order',
        fr: 'Enregistrer la commande',
        nl: 'Bestelling opslaan',
        es: 'Guardar pedido',
    },
    filters: {
        en: 'Filters',
        fr: 'Filtres',
        nl: 'Filters',
        es: 'Filtros',
    },
    reduce: {
        en: 'Reduce',
        fr: 'Réduire',
        nl: 'Verkleinen',
        es: 'Reducir',
    },
    extend: {
        en: 'Extend',
        fr: 'Agrandir',
        nl: 'Verlengen',
        es: 'Extender',
    },
    validate: {
        en: 'Validate',
        fr: 'Valider',
        nl: 'Bevestigen',
        es: 'Validar',
    },
    validateOrderQuote: {
        en: 'Validate the quote',
        fr: 'Valider le devis',
        nl: 'Bevestig de offerte',
        es: 'Validar la cotización',
    },
    serviceSaved: {
        fr: 'La prestation a bien été enregistrée',
        en: 'The service has been successfully saved',
        nl: 'De service is succesvol opgeslagen',
        es: 'El servicio se ha guardado con éxito',
    },
    validateAddress: {
        en: 'Validate address',
        fr: "Valider l'adresse",
        nl: 'Bevestig adres',
        es: 'Validar dirección',
    },
    validatedAddress: {
        en: 'Validated address',
        fr: 'Adresse validée',
        nl: 'Gevalideerd adres',
        es: 'Dirección validada',
    },
    add: {
        en: 'Add',
        fr: 'Ajouter',
        nl: 'Toevoegen',
        es: 'Agregar',
    },
    integrateAddresses: {
        en: 'Integrate addresses',
        fr: 'Intégrer des adresses',
        nl: 'Adressen integreren',
        es: 'Integrar direcciones',
    },
    integrateDepartments: {
        en: 'Integrate departments',
        fr: 'Intégrer des départements',
        nl: 'Integreer afdelingen',
        es: 'Integrar departamentos',
    },
    integrateDeliveryTimes: {
        en: 'Integrate delivery times',
        fr: 'Intégrer des délais de livraison',
        nl: 'Integreer levertijden',
        es: 'Integrar tiempos de entrega',
    },
    downloadTemplate: {
        en: 'Download template',
        fr: 'Télécharger le template',
        nl: 'Download template',
        es: 'Descargar plantilla',
    },
    dataIntegrationCompleted: {
        en: 'Data integration completed',
        fr: 'Intégration des données terminée',
        nl: 'Gegevensintegratie voltooid',
        es: 'Integración de datos completada',
    },
    downloadExample: {
        en: 'Download example',
        fr: 'Télécharger un exemple',
        nl: 'Download een voorbeeld',
        es: 'Descargar ejemplo',
    },
    addDefaultAddress: {
        en: 'Set as default address',
        fr: 'Définir comme adresse par défaut',
        nl: 'Instellen als standaardadres',
        es: 'Establecer como dirección predeterminada',
    },
    addContact: {
        en: 'Add contact',
        fr: 'Ajouter un contact',
        nl: 'Contact toevoegen',
        es: 'Agregar contacto',
    },
    addEmail: {
        en: 'Add email',
        fr: 'Ajouter un e-mail',
        nl: 'E-mail toevoegen',
        es: 'Agregar correo electrónico',
    },
    editContact: {
        en: 'Edit contact',
        fr: 'Modifier le contact',
        nl: 'Bewerk contact',
        es: 'Editar contacto',
    },
    removeDelivery: {
        en: 'Delete delivery',
        fr: 'Supprimer la livraison',
        nl: 'Levering verwijderen',
        es: 'Eliminar entrega',
    },
    removeAddress: {
        en: 'Delete address',
        fr: "Supprimer l'adresse",
        nl: 'Adres verwijderen',
        es: 'Eliminar dirección',
    },
    removeDepartment: {
        en: 'Delete department',
        fr: 'Supprimer le département',
        nl: 'Afdeling verwijderen',
        es: 'Eliminar departamento',
    },
    removeOperatingCenter: {
        en: 'Delete operating center',
        fr: "Supprimer le centre d'exploitation",
        nl: 'Exploitatiecentrum verwijderen',
        es: 'Eliminar centro de operación',
    },
    removeDeliveryTime: {
        en: 'Delete delivery time',
        fr: 'Supprimer le délai de livraison',
        nl: 'Bezorgtijd verwijderen',
        es: 'Eliminar tiempo de entrega',
    },
    modalEditOperatingCenterTitle: {
        en: 'Edit operating center',
        fr: "Modifier le centre d'exploitation",
        nl: 'Wijzig het exploitatiecentrum',
        es: 'Editar centro de operación',
    },
    modalOperatingCenterTitle: {
        en: 'Add a operating center',
        fr: "Ajouter un centre d'exploitation",
        nl: 'Voeg een exploitatiecentrum toe',
        es: 'Agregar un centro de operación',
    },
    modalEditDeliveryTimeTitle: {
        en: 'Edit delivery time',
        fr: 'Modifier le délai de livraison',
        nl: 'Levertijd bewerken',
        es: 'Editar tiempo de entrega',
    },
    modalDeliveryTimeTitle: {
        en: 'Add a delivery time',
        fr: 'Ajouter un délai de livraison',
        nl: 'Voeg een bezorgtijd toe',
        es: 'Agregar un tiempo de entrega',
    },
    modalEditAccessibilityTitle: {
        en: 'Edit accessibility',
        fr: "Modifier l'accessibilité",
        nl: 'Toegankelijkheid bewerken',
        es: 'Editar accesibilidad',
    },
    modalAccessibilityTitle: {
        en: 'Add accessibility',
        fr: 'Ajouter une accessibilité',
        nl: 'Toegankelijkheid toevoegen',
        es: 'Agregar accesibilidad',
    },
    removeAccessibility: {
        en: 'Remove accessibility',
        fr: "Supprimer l'accessibilité",
        nl: 'Toegankelijkheid verwijderen',
        es: 'Eliminar accesibilidad',
    },
    sureRemoveAccessibility: {
        en: 'Are you sure you want to remove accessibility? This action is final.',
        fr: "Êtes-vous certain de vouloir supprimer l'accessibilité ? Cette action est définitive.",
        nl: 'Weet u zeker dat u de toegankelijkheid wilt verwijderen? Deze actie is definitief.',
        es: '¿Está seguro de que desea eliminar la accesibilidad? Esta acción es definitiva.',
    },
    rejectAddressTitle: {
        en: 'Reject address',
        fr: "Refuser l'adresse",
        nl: 'Adres weigeren',
        es: 'Rechazar dirección',
    },
    rejectAddressSubTitle: {
        en: 'Are you sure you want to reject the address? This action is final and will cancel the associated order(s).',
        fr: "Êtes-vous certain de vouloir refuser l'adresse ? Cette action est définitive et annulera la ou les commandes associées.",
        nl: 'Weet u zeker dat u het adres wilt weigeren? Deze actie is definitief en annuleert de bijbehorende bestelling(en).',
        es: '¿Está seguro de que desea rechazar la dirección? Esta acción es definitiva y cancelará la o las órdenes asociadas.',
    },
    removeDefaultAddress: {
        en: 'Remove default address',
        fr: "Supprimer l'adresse par défaut",
        nl: 'Standaard adres verwijderen',
        es: 'Eliminar dirección predeterminada',
    },
    delete: {
        en: 'Delete',
        fr: 'Supprimer',
        nl: 'Verwijderen',
        es: 'Eliminar',
    },
    cancelOrder: {
        en: 'Cancel the order',
        fr: 'Annuler la commande',
        nl: 'De bestelling annuleren',
        es: 'Cancelar la orden',
    },
    upload: {
        en: 'Upload',
        fr: 'Téléverser',
        nl: 'Uploaden',
        es: 'Subir',
    },
    download: {
        en: 'Download',
        fr: 'Télécharger',
        nl: 'Downloaden',
        es: 'Descargar',
    },
    downloadFailed: {
        en: 'Download failed',
        fr: 'Téléchargement impossible.',
        nl: 'Download mislukt',
        es: 'No se pudo descargar',
    },
    view: {
        en: 'View',
        fr: 'Visionner',
        nl: 'Bekijken',
        es: 'Ver',
    },
    modalDeleteTitle: {
        en: 'Delete the order',
        fr: 'Supprimer la commande',
        nl: 'Bestelling verwijderen',
        es: 'Eliminar la orden',
    },
    sendTrackingLinkSubtitle: {
        en: 'Select the delivery for which you want to send the tracking link.\nWhen you select a delivery, the email address associated with the contact address automatically populates the 1st email address.\nYou can modify the email address or add more.\nClick the Send button to send the tracking link.',
        fr: "Sélectionnez la livraison pour laquelle vous souhaitez envoyer le lien de suivi.\nLorsque vous sélectionnez une livraison, l'adresse e-mail associée à l'adresse contact renseigne automatiquement la 1ère adresse e-mail.\nVous pouvez modifier l'adresse e-mail ou en ajouter d'autres.\nCliquez sur le bouton Envoyer pour envoyer le lien de suivi.",
        nl: 'Selecteer de bezorging waarvoor u de trackinglink wilt verzenden.\nAls u een bezorging selecteert, wordt automatisch het eerste e-mailadres ingevuld met het e-mailadres dat is gekoppeld aan het contactadres.\nU kunt het e-mailadres wijzigen of meer toevoegen.\nKlik de knop Verzenden om de trackinglink te verzenden.',
        es: 'Seleccione la entrega para la que desea enviar el enlace de seguimiento.\nCuando selecciona una entrega, la dirección de correo electrónico asociada a la dirección de contacto completa automáticamente la primera dirección de correo electrónico.\nPuede modificar la dirección de correo electrónico o agregar más.\nHaga clic en el botón Enviar para enviar el enlace de seguimiento.',
    },
    modalDeleteSubtitle: {
        en: 'Are you sure you want to delete the order ? This action is definitive.',
        fr: 'Êtes-vous certains de vouloir supprimer la commande ? Cette action est définitive.',
        nl: 'Weet u zeker dat u de bestelling wilt verwijderen ? Deze actie is definitief.',
        es: '¿Está seguro de que desea eliminar la orden? Esta acción es definitiva.',
    },
    modalCancelTitle: {
        en: 'Cancel the order',
        fr: 'Annuler la commande',
        nl: 'De bestelling annuleren',
        es: 'Cancelar la orden',
    },
    modalCancelSubtitle: {
        en: 'Are you sure you want to cancel the order ? This action is definitive.',
        fr: 'Êtes-vous certains de vouloir annuler la commande ? Cette action est définitive.',
        nl: 'Weet je zeker dat je de bestelling wilt annuleren? Deze actie is definitief.',
        es: '¿Está seguro de que desea cancelar la orden? Esta acción es definitiva.',
    },
    modalCancelNotPossibleSubtitle: {
        en: 'You cannot cancel this order as it has been validated already. Please contact the operating center at this email : {{0}}.',
        fr: "Vous ne pouvez pas annuler cette commande car elle a déjà été validée. Veuillez contacter le centre d'exploitation à l'email suivant : {{0}}.",
        nl: 'U kunt deze bestelling niet annuleren omdat deze al is gevalideerd. Neem contact op met het exploitatiecentrum via het volgende e-mailadres: {{0}}.',
        es: 'No puede cancelar esta orden ya que ya ha sido validada. Por favor, contacte con el centro operativo en este correo electrónico: {{0}}.',
    },
    modalNextStepTitle: {
        en: 'Validate to the next step of the order',
        fr: "Valider l'étape de la commande",
        nl: 'Valideer de bestelstap',
        es: 'Validar el siguiente paso de la orden',
    },
    modalNextStepSubtitle: {
        en: 'Are you sure you want to take the next step ? This action is final.',
        fr: "Êtes-vous certain de vouloir passer à l'étape suivante ? Cette action est définitive.",
        nl: 'Weet je zeker dat je de volgende stap wilt zetten ? Deze actie is definitief.',
        es: '¿Está seguro de que desea tomar el siguiente paso? Esta acción es definitiva.',
    },
    modalNextStepMessage: {
        en: 'Element has been successfully validated',
        fr: "L'élément a bien été validé",
        nl: 'Het element is gevalideerd',
        es: 'El elemento ha sido validado con éxito',
    },
    modalDeleteMessage: {
        en: 'Element has been successfully deleted',
        fr: "L'élément a bien été supprimé",
        nl: 'Het element is succesvol verwijderd',
        es: 'El elemento ha sido eliminado con éxito',
    },
    modalCancelOrderMessage: {
        en: 'Order creation has been successfully canceled',
        fr: 'La création de commande a bien été annulée',
        nl: 'Het maken van de bestelling is met succes geannuleerd',
        es: 'La creación de la orden ha sido cancelada con éxito',
    },
    modalCancelMessage: {
        en: 'Element has been successfully cancelled',
        fr: "L'élément a bien été annulé",
        nl: 'Het item is succesvol geannuleerd',
        es: 'El elemento ha sido cancelado con éxito',
    },
    modalValidateTitle: {
        en: 'Validate the order',
        fr: 'Valider la commande',
        nl: 'Valideer de bestelling',
        es: 'Validar la orden',
    },
    modalValidateSubtitle: {
        en: 'You are about to validate your order, you will not be able to change the information provided thereafter.',
        fr: 'Vous êtes sur le point de valider votre commande, vous ne pourrez plus changer les informations renseignées par la suite.',
        nl: 'U staat op het punt uw bestelling te valideren, u kunt de verstrekte informatie daarna niet meer wijzigen.',
        es: 'Está a punto de validar su orden, no podrá cambiar la información proporcionada posteriormente.',
    },
    modalValidateAfterSaveTitle: {
        en: 'Order Saved, do you want to validate it too ?',
        fr: 'Commande enregistrée, voulez-vous la valider également ?',
        nl: 'Bestelling opgeslagen, wilt u deze ook valideren ?',
        es: 'Orden guardada, ¿desea validarla también?',
    },
    modalValidateAfterSaveSubtitle: {
        en: 'Your order has been registered and you are about to validate it, you will not be able to change the information provided subsequently.',
        fr: 'Votre commande est enregistrée et vous êtes sur le point de la valider, vous ne pourrez plus changer les informations renseignées par la suite.',
        nl: 'Uw bestelling is geregistreerd en u staat op het punt deze te valideren, u kunt de verstrekte informatie daarna niet meer wijzigen.',
        es: 'Su orden ha sido registrada y está a punto de validarla, no podrá cambiar la información proporcionada posteriormente.',
    },
    new: {
        en: 'New',
        fr: 'Nouveau',
        nl: 'Nieuw',
        es: 'Nuevo',
    },
    newInvoice: {
        en: 'New invoice',
        fr: 'Nouvelle facture',
        nl: 'Nieuwe factuur',
        es: 'Nueva factura',
    },
    newDocument: {
        en: 'New document',
        fr: 'Nouveau document',
        nl: 'Nieuw document',
        es: 'Nuevo documento',
    },
    newUser: {
        en: 'New user',
        fr: 'Nouvel utilisateur',
        nl: 'Nieuwe gebruiker',
        es: 'Nuevo usuario',
    },
    newClient: {
        en: 'New client',
        fr: 'Nouveau client',
        nl: 'Nieuwe klant',
        es: 'Nuevo cliente',
    },
    newHomeArticle: {
        en: 'New novelty',
        fr: 'Nouvelle nouveauté',
        nl: 'Nieuwe nieuwigheid',
        es: 'Nueva novedad',
    },
    newHomeActuality: {
        en: 'New actuality',
        fr: 'Nouvelle actualité',
        nl: 'Nieuwe actualiteit',
        es: 'Nueva actualidad',
    },
    newClientAccount: {
        en: 'New client account',
        fr: 'Nouveau compte client',
        nl: 'Nieuwe klantrekening',
        es: 'Nueva cuenta cliente',
    },
    softDeletedUserExistsTitle: {
        en: 'This client already has a deleted account',
        fr: 'Ce client possède déjà un compte supprimé',
        nl: 'Deze klant heeft al een verwijderd account',
        es: 'Este cliente ya tiene una cuenta eliminada',
    },
    softDeletedUserExistsMessage: {
        en: 'A matching account already exists in the system but is currently disabled. Do you want to reactivate this account?',
        fr: 'Un compte correspondant à ce client existe déjà dans le système, mais il est actuellement désactivé. Voulez-vous réactiver ce compte ?',
        nl: 'Er bestaat al een overeenkomend account in het systeem, maar het is momenteel uitgeschakeld. Wilt u dit account opnieuw activeren?',
        es: 'Ya existe una cuenta correspondiente a este cliente en el sistema, pero actualmente está desactivada. ¿Desea reactivar esta cuenta?',
    },
    reactivateAccount: {
        en: 'Reactivate account',
        fr: 'Réactiver le compte',
        nl: 'Account opnieuw activeren',
        es: 'Reactivar cuenta',
    },
    modify: {
        en: 'Modify',
        fr: 'Modifier',
        nl: 'Bewerken',
        es: 'Modificar',
    },
    yes: {
        en: 'Yes',
        fr: 'Oui',
        nl: 'Ja',
        es: 'Sí',
    },
    no: {
        en: 'No',
        fr: 'Non',
        nl: 'Nee',
        es: 'No',
    },
    deliveries: {
        en: 'Deliveries',
        fr: 'Livraisons',
        nl: 'Leveringen',
        es: 'Entregas',
    },
    delivery: {
        en: 'Delivery',
        fr: 'Livraison',
        nl: 'Levering',
        es: 'Entrega',
    },
    deliveryInstruction: {
        en: 'Delivery instructions',
        fr: 'Instructions livraison',
        nl: 'Leveringsinstructies',
        es: 'Instrucciones de entrega',
    },
    assiociatedDelivery: {
        en: 'Associated delivery',
        fr: 'Livraison associée',
        nl: 'Bijbehorende levering',
        es: 'Entrega asociada',
    },
    comment: {
        en: 'Comment',
        fr: 'Commentaire',
        nl: 'Opmerking',
        es: 'Comentario',
    },
    commentMeeting: {
        en: 'Comment related to the meeting',
        fr: 'Commentaire lié au rendez-vous',
        nl: 'Opmerking met betrekking tot de afspraak',
        es: 'Comentario relacionado con la reunión',
    },
    commentOrder: {
        en: 'Invoice comment related to the order',
        fr: 'Commentaire facture sur la commande',
        nl: 'Algemene opmerking over de bestelling',
        es: 'Comentario de factura relacionado con el pedido',
    },
    document: {
        en: 'Document',
        fr: 'Document',
        nl: 'Document',
        es: 'Documento',
    },
    insurance: {
        en: 'Insurance',
        fr: 'Assurance',
        nl: 'Verzekering',
        es: 'Seguro',
    },
    invoice: {
        en: 'Invoice',
        fr: 'Facture',
        nl: 'Factuur',
        es: 'Factura',
    },
    invoiceDate: {
        en: 'Invoice date',
        fr: 'Date facture',
        nl: 'Factuurdatum',
        es: 'Fecha factura',
    },
    intermediateWorkflowSteps: {
        en: 'Intermediate workflow steps',
        fr: 'Étapes du workflow intermédiaire',
        nl: 'Intermediaire workflowstappen',
        es: 'Pasos intermedios del flujo de trabajo',
    },
    packing: {
        en: 'Packing list',
        fr: 'Liste de colisage',
        nl: 'Paklijst',
        es: 'Lista de empaque',
    },
    page: {
        en: 'Page',
        fr: 'Page',
        nl: 'Pagina',
        es: 'Página',
    },
    assuranceDocument: {
        en: 'Insurance',
        fr: 'Assurance',
        nl: 'Verzekering',
        es: 'Seguro',
    },
    customsDocument: {
        en: 'Customs',
        fr: 'Douane',
        nl: 'Douane',
        es: 'Aduana',
    },
    ifSoYouWillBeAskedForAnAdditionalDocument: {
        en: 'If so, you will be asked for an additional document',
        fr: 'Si oui, un document supplémentaire vous sera demandé',
        nl: 'Dan wordt u om een aanvullend document gevraagd ',
        es: 'Si es así, se le pedirá un documento adicional',
    },
    yourAccount: {
        en: 'Your account',
        fr: 'Votre compte',
        nl: 'Uw account',
        es: 'Tu cuenta',
    },
    username: {
        en: 'Username',
        fr: 'Nom utilisateur',
        nl: 'Gebruikersnaam',
        es: 'Nombre de usuario',
    },
    commandPortal: {
        en: 'Order portal',
        fr: 'Portail commande',
        nl: 'Bestelportaal',
        es: 'Portal de pedidos',
    },
    allTransports: {
        en: 'My transports',
        fr: 'Mes transports',
        nl: 'Mijn transporten',
        es: 'Mis transportes',
    },
    allOrders: {
        en: 'My orders',
        fr: 'Toutes mes commandes',
        nl: 'Mijn bestellingen',
        es: 'Mis pedidos',
    },
    allOrdersPickup: {
        en: 'My pickup orders',
        fr: 'Toutes mes commandes de chargement',
        nl: 'Al mijn laadopdrachten',
        es: 'Mis órdenes de carga',
    },
    allOrdersDelivery: {
        en: 'My delivery orders',
        fr: 'Toutes mes commandes de livraison',
        nl: 'Al mijn bezorgbestellingen',
        es: 'Mis órdenes de entrega',
    },
    order: {
        en: 'Order',
        fr: 'Commande',
        nl: 'Bestelling',
        es: 'Orden',
    },
    orders: {
        en: 'Orders',
        fr: 'Commandes',
        nl: 'Bestellingen',
        es: 'Órdenes',
    },
    orderSettings: {
        en: 'Order settings',
        fr: 'Paramètres de commande',
        nl: 'Bestelinstellingen',
        es: 'Configuración de órdenes',
    },
    myOrders: {
        en: 'My orders',
        fr: 'Mes commandes',
        nl: 'Mijn bestellingen',
        es: 'Mis órdenes',
    },
    myOrdersToValidate: {
        en: 'My orders to validate',
        fr: 'Mes commandes à valider',
        nl: 'Mijn te valideren bestellingen',
        es: 'Mis órdenes para validar',
    },
    myOrdersToValidatePickup: {
        en: 'My pickup orders to validate',
        fr: 'Mes commandes de chargement à valider',
        nl: 'Mijn te valideren laadopdrachten',
        es: 'Mis órdenes de carga para validar',
    },
    myOrdersWaitingForConfirmation: {
        en: 'My orders waiting for confirmation',
        fr: 'Mes commandes en attente de validation',
        nl: 'Mijn bestellingen in afwachting van validatie',
        es: 'Mis órdenes esperando confirmación',
    },
    myOrdersConfirmed: {
        en: 'My orders confirmed',
        fr: 'Mes commandes confirmées',
        nl: 'Mijn bevestigde bestellingen',
        es: 'Mis órdenes confirmadas',
    },
    myOrdersConfirmedPickup: {
        en: 'My pickup orders confirmed',
        fr: 'Mes commandes de chargement confirmées',
        nl: 'Mijn bevestigde laadopdrachten',
        es: 'Mis órdenes de carga confirmadas',
    },
    myOrdersConfirmedDelivery: {
        en: 'My delivery orders confirmed',
        fr: 'Mes commandes de livraison confirmées',
        nl: 'Mijn bevestigde leveringsbestellingen',
        es: 'Mis órdenes de entrega confirmadas',
    },
    myOrdersTreated: {
        en: 'My orders treated',
        fr: 'Mes commandes traitées',
        nl: 'Mijn verwerkte bestellingen',
        es: 'Mis órdenes tratadas',
    },
    myOrdersTreatedPickup: {
        en: 'My pickup orders treated',
        fr: 'Mes commandes de chargement traitées',
        nl: 'Mijn verwerkte laadopdrachten',
        es: 'Mis órdenes de carga tratadas',
    },
    myOrdersTreatedDelivery: {
        en: 'My delivery orders treated',
        fr: 'Mes commandes de livraison traitées',
        nl: 'Mijn verwerkte bezorgopdrachten',
        es: 'Mis órdenes de entrega tratadas',
    },
    myOrdersCancelled: {
        en: 'My orders cancelled',
        fr: 'Mes commandes annulées',
        nl: 'Mijn geannuleerde bestellingen',
        es: 'Mis órdenes canceladas',
    },
    street: {
        en: 'Number/Street',
        fr: 'Numéro/Rue',
        nl: 'Nummer/Straat',
        es: 'Número/Calle',
    },
    city: {
        en: 'City',
        fr: 'Ville',
        nl: 'Stad',
        es: 'Ciudad',
    },
    cityZipcode: {
        en: 'City / Zipcode',
        fr: 'Ville / Code Postal',
        nl: 'Stad / Postcode',
        es: 'Ciudad / Código Postal',
    },
    zipcode: {
        en: 'Zipcode',
        fr: 'Code Postal',
        nl: 'Postcode',
        es: 'Código Postal',
    },
    country: {
        en: 'Country',
        fr: 'Pays',
        nl: 'Land',
        es: 'País',
    },
    deliveryAndPickupAddresses: {
        en: 'Delivery and pickup addresses',
        fr: 'Adresses de livraison et de chargement',
        nl: 'Bezorg- en ophaaladressen',
        es: 'Direcciones de entrega y recogida',
    },
    contentOfTheOrder: {
        en: 'Content of the order',
        fr: 'Contenu de la commande',
        nl: 'Inhoud van de bestelling',
        es: 'Contenido de la orden',
    },
    deliveryAddress: {
        en: 'Delivery address',
        fr: 'Adresse de livraison',
        nl: 'Bezorgadres',
        es: 'Dirección de entrega',
    },
    deliveryAddressInfo: {
        en: 'Delivery address information',
        fr: 'Informations adresse de livraison',
        nl: 'Afleveradres informatie',
        es: 'Información de la dirección de entrega',
    },
    pickupAddress: {
        en: 'Pickup address',
        fr: "Adresse d'enlèvement",
        nl: 'Ophaaladres',
        es: 'Dirección de recogida',
    },
    pickupAddressInfo: {
        en: 'Pickup address information',
        fr: 'Informations adresse de chargement',
        nl: 'Adresgegevens laden',
        es: 'Información de la dirección de recogida',
    },
    newPickupAddress: {
        en: 'New pickup address',
        fr: 'Nouvelle adresse de chargement',
        nl: 'Nieuw laadadres',
        es: 'Nueva dirección de recogida',
    },
    newDeliveryAddress: {
        en: 'New delivery address',
        fr: 'Nouvelle adresse de livraison',
        nl: 'Nieuw afleveradres',
        es: 'Nueva dirección de entrega',
    },
    validatePickupAddress: {
        en: 'Validate / modify pickup address',
        fr: "Valider / modifier l'adresse de chargement",
        nl: 'Valideer / wijzig het laadadres',
        es: 'Validar / modificar dirección de recogida',
    },
    validateDeliveryAddress: {
        en: 'Validate / modify delivery address',
        fr: "Valider / modifier l'adresse de livraison",
        nl: 'Valideer / wijzig het afleveradres',
        es: 'Validar / modificar dirección de entrega',
    },
    deliveryOperatingCenter: {
        en: 'Delivery operating center',
        fr: "Centre d'exploitation de livraison",
        nl: 'Levering exploitatiecentrum',
        es: 'Centro de operaciones de entrega',
    },
    pickupOperatingCenter: {
        en: 'Pickup operating center',
        fr: "Centre d'exploitation de chargement",
        nl: 'Ophaal exploitatiecentrum',
        es: 'Centro de operaciones de recogida',
    },
    step: {
        en: 'Step',
        fr: 'Étape',
        nl: 'Stap',
        es: 'Paso',
    },
    nextStep: {
        en: 'Next step',
        fr: 'Étape suivante',
        nl: 'Volgende stap',
        es: 'Siguiente paso',
    },
    productType: {
        en: 'Product type',
        fr: 'Type de produit',
        nl: 'Producttype',
        es: 'Tipo de producto',
    },
    productTypes: {
        en: 'Product types',
        fr: 'Types de produit',
        nl: 'Producttypes',
        es: 'Tipos de producto',
    },
    productTemperature: {
        en: 'Product temperature',
        fr: 'Température du produit',
        nl: 'Producttemperatuur',
        es: 'Temperatura del producto',
    },
    temperature: {
        en: 'Temperature',
        fr: 'Température',
        nl: 'Temperatuur',
        es: 'Temperatura',
    },
    temperatureIsRequired: {
        en: 'A temperature must be selected',
        fr: 'Une température doit être sélectionnée',
        nl: 'Er moet een temperatuur worden geselecteerd',
        es: 'Se debe seleccionar una temperatura',
    },
    dateMustBeSelected: {
        en: 'Date must be selected',
        fr: 'La date doit être sélectionnée',
        nl: 'Datum moet worden geselecteerd',
        es: 'Se debe seleccionar una fecha',
    },
    aSupportMustBeSelected: {
        en: 'A support must be selected',
        fr: 'Un support doit être sélectionné',
        nl: 'Er moet een ondersteuning worden geselecteerd',
        es: 'Se debe seleccionar un soporte',
    },
    anArticleMustBeSelected: {
        en: 'An article must be selected',
        fr: 'Un article doit être sélectionné',
        nl: 'Er moet een artikel worden geselecteerd',
        es: 'Se debe seleccionar un artículo',
    },
    quantity: {
        en: 'Quantity',
        fr: 'Quantité',
        nl: 'Hoeveelheid',
        es: 'Cantidad',
    },
    productQuantity: {
        en: 'Product quantity',
        fr: 'Quantité du produit',
        nl: 'Producthoeveelheid',
        es: 'Cantidad del producto',
    },
    productWeight: {
        en: 'Product weight',
        fr: 'Poids du produit',
        nl: 'Productgewicht',
        es: 'Peso del producto',
    },
    meeting: {
        en: 'Meeting',
        fr: 'Rendez-vous',
        nl: 'Afspraak',
        es: 'Reunión',
    },
    meetingMandatory: {
        en: 'Meeting mandatory',
        fr: 'Rendez-vous obligatoire',
        nl: 'Afspraak verplicht',
        es: 'Reunión obligatoria',
    },
    isTheMeetingMandatoryInOrderToPickUpTheOrder: {
        en: 'Is the meeting mandatory in order to pick up the order ?',
        fr: 'Rdv obligatoire pour retirer la commande ?',
        nl: 'Is de afspraak verplicht om de bestelling op te halen ?',
        es: '¿Es obligatoria la reunión para recoger el pedido ?',
    },
    isTheMeetingMandatoryInOrderToDeliverTheOrder: {
        en: 'Is the meeting mandatory in order to deliver the order ?',
        fr: 'Rdv obligatoire pour livrer la commande ?',
        nl: 'Is de afspraak verplicht om de bestelling te bezorgen ?',
        es: '¿Es obligatoria la reunión para entregar el pedido ?',
    },
    isVisible: {
        en: 'Is active ?',
        fr: 'Est actif ?',
        nl: 'Is actief ?',
        es: '¿Está activo ?',
    },
    isAddressVisibleAdmin: {
        fr: 'Cette adresse est visible par les clients',
        en: 'This address is visible by customers',
        nl: 'Dit adres is zichtbaar voor klanten',
        es: 'Esta dirección es visible por los clientes',
    },
    isAddressVisible: {
        en: 'This address is recurrent, I want to save it in my address book',
        fr: "Cette adresse est récurrente, je souhaite l'enregistrer dans mon carnet d'adresses",
        nl: 'Dit adres is terugkerend, ik wil het opslaan in mijn adresboek',
        es: 'Esta dirección es recurrente, quiero guardarla en mi libreta de direcciones',
    },
    isValidated: {
        en: 'Is validated?',
        fr: 'Est validé ?',
        nl: 'Is het gevalideerd?',
        es: '¿Está validado?',
    },
    isRejected: {
        en: 'Is rejected?',
        fr: 'Est rejeté ?',
        nl: 'Is het afgewezen?',
        es: '¿Está rechazado?',
    },
    isValidateExploitationRequired: {
        en: 'V. exploitation required ?',
        fr: 'V. exploitation requise ?',
        nl: 'V. exploitatie vereist ?',
        es: '¿Se requiere validación de explotación?',
    },
    isAddressValidationRequired: {
        en: 'V. address required ?',
        fr: 'V. adresse requise ?',
        nl: 'V. adres vereist ?',
        es: '¿Se requiere validación de dirección?',
    },
    isPickupAddress: {
        en: 'Is pickup address',
        fr: "Adresse d'enlèvement",
        nl: 'Is ophaaladres',
        es: '¿Es dirección de recogida?',
    },
    isDeliveryAddress: {
        en: 'Is delivery address',
        fr: 'Adresse de livraison',
        nl: 'Is afleveradres',
        es: '¿Es dirección de entrega?',
    },
    documents: {
        en: 'Documents',
        fr: 'Documents',
        nl: 'Documenten',
        es: 'Documentos',
    },
    deliveryReference: {
        en: 'Delivery reference',
        fr: 'Référence livraison',
        nl: 'Leveringsreferentie',
        es: 'Referencia de entrega',
    },
    pickupReference: {
        en: 'Pickup reference',
        fr: 'Référence chargement',
        nl: 'Laadreferentie',
        es: 'Referencia de recogida',
    },
    clientName: {
        en: 'Client name',
        fr: 'Nom du client',
        nl: 'Klantnaam',
        es: 'Nombre del cliente',
    },
    companyName: {
        en: 'Company name',
        fr: 'Nom de la société',
        nl: 'Bedrijfsnaam',
        es: 'Nombre de la empresa',
    },
    setCompanyOperational: {
        en: 'Set company operational',
        fr: 'Mettre la société en exploitation',
        nl: 'Zet het bedrijf in exploitatie',
        es: 'Establecer la empresa en operación',
    },
    setCompanyNonOperational: {
        en: 'Set company non operational',
        fr: 'Mettre la société hors exploitation',
        nl: 'Zet het bedrijf buiten exploitatie',
        es: 'Establecer la empresa no operativa',
    },
    complements: {
        en: 'Complements',
        fr: 'Compléments',
        nl: 'Aanvullingen',
        es: 'Complementos',
    },
    doYouNeedAnInsurance: {
        en: 'Do you need insurance ?',
        fr: "Avez-vous besoin d'une assurance ?",
        nl: 'Heeft u een verzekering nodig ?',
        es: '¿Necesita un seguro?',
    },
    modalAddressDefaultTitle: {
        en: 'Add the address of the client {{clientName}}',
        fr: "Ajouter l'adresse du client {{clientName}}",
        nl: 'Voeg het adres van de klant {{clientName}} toe',
        es: 'Agregar la dirección del cliente {{clientName}}',
    },
    addressWillBeControlledByCompany: {
        en: 'All new addresses (or modifications) will be checked in advance of your order by the {{companyName}} team.',
        fr: 'Toute nouvelle adresse (ou modification) sera contrôlée en amont de votre commande par l’équipe {{companyName}}.',
        nl: 'Alle nieuwe adressen (of wijzigingen) worden voorafgaand aan uw bestelling gecontroleerd door het {{companyName}}-team.',
        es: 'Todas las nuevas direcciones (o modificaciones) serán revisadas con anticipación a su pedido por el equipo de {{companyName}}.',
    },
    addressValidation: {
        en: 'Address validation',
        fr: "Validation de l'adresse",
        nl: 'Adresvalidatie',
        es: 'Validación de dirección',
    },
    operatorValidation: {
        en: 'Operator validation',
        fr: "Validation de l'opérateur",
        nl: 'Operatorvalidatie',
        es: 'Validación de operador',
    },
    workflowStep: {
        en: 'Workflow step',
        fr: 'Étape du workflow',
        nl: 'Workflowstap',
        es: 'Paso del flujo de travail',
    },
    waybills: {
        en: 'Waybills',
        fr: 'Lettres de voiture',
        nl: 'Vrachtbrieven',
        es: 'Cartas de porte',
    },
    myWaybills: {
        en: 'My waybills',
        fr: 'Mes lettres de voiture',
        nl: 'Mijn vrachtbrieven',
        es: 'Mis cartas de porte',
    },
    waybillNotDownloadable: {
        en: 'The waybill {{waybill}} is not downloadable.',
        fr: "La lettre de voiture {{waybill}} n'est pas téléchargeable.",
        nl: 'De vrachtbrief {{waybill}} is niet downloadbaar.',
        es: 'La carta de porte {{waybill}} no está disponible para descarga.',
    },
    emailHasBeenGenerated: {
        en: 'An automatic email has been generated.',
        fr: 'Un e-mail automatique a été généré.',
        nl: 'Er is een automatische e-mail gegenereerd.',
        es: 'Se ha generado un correo electrónico automático.',
    },
    modalAddressValidationTitle: {
        en: 'Validate / modify address',
        fr: "Valider / modifier l'adresse",
        nl: 'Valideer / wijzig het adres',
        es: 'Validar / modificar dirección',
    },
    modalAddressTitle: {
        en: 'Add a new address',
        fr: 'Ajouter une nouvelle adresse',
        nl: 'Voeg een nieuw adres toe',
        es: 'Agregar una nueva dirección',
    },
    modalValidAddressTitle: {
        en: 'Validate an address',
        fr: 'Valider une adresse',
        nl: 'Een adres valideren',
        es: 'Validar una dirección',
    },
    modalEditAddressTitle: {
        en: 'Edit an address',
        fr: 'Modifier une adresse',
        nl: 'Een adres wijzigen',
        es: 'Editar una dirección',
    },
    modalEditLogisticConstraintTitle: {
        en: 'Edit a logistic constraint',
        fr: 'Modifier la contrainte logistique',
        nl: 'Een logistieke beperking bewerken',
        es: 'Editar una restricción logística',
    },
    modalEditDeliveryTypeTitle: {
        en: 'Edit a delivery type',
        fr: 'Modifier le type de livraison',
        nl: 'Een leveringstype bewerken',
        es: 'Editar un tipo de entrega',
    },
    modalEditDepartmentTitle: {
        en: 'Edit department',
        fr: 'Modifier le département',
        nl: 'Verander afdeling',
        es: 'Editar departamento',
    },
    modalDepartmentTitle: {
        en: 'Add a department',
        fr: 'Ajouter un département',
        nl: 'Voeg een afdeling toe',
        es: 'Agregar un departamento',
    },
    modalDeliveryTypeTitle: {
        en: 'Add a delivery type',
        fr: 'Ajouter un type de livraison',
        nl: 'Voeg een leveringstype toe',
        es: 'Agregar un tipo de entrega',
    },
    modalLogisticConstraintTitle: {
        en: 'Add a logistic constraint',
        fr: 'Ajouter une contrainte logistique',
        nl: 'Voeg een logistieke beperking toe',
        es: 'Agregar una restricción logística',
    },
    modalPickupInstructionTitle: {
        en: 'Pickup instruction',
        fr: "Instruction d'enlèvement",
        nl: 'Ophaalinstructie',
        es: 'Instrucción de recogida',
    },
    modalDeliveryInstructionTitle: {
        en: 'Delivery instruction',
        fr: 'Instruction de livraison',
        nl: 'Leveringsinstructie',
        es: 'Instrucción de entrega',
    },
    writePickupInstruction: {
        en: 'Write a pickup instruction',
        fr: "Écrire une instruction d'enlèvement",
        nl: 'Schrijf een ophaalinstructie',
        es: 'Escribir una instrucción de recogida',
    },
    writeDeliveryInstruction: {
        en: 'Write a delivery instruction',
        fr: 'Écrire une instruction de livraison',
        nl: 'Schrijf een leveringsinstructie',
        es: 'Escribir una instrucción de entrega',
    },
    modalEditContactTitle: {
        en: 'Edit a contact',
        fr: 'Modifier un contact',
        nl: 'Een contact bewerken',
        es: 'Editar un contacto',
    },
    modalClientContactTitle: {
        en: 'Add a contact for the address of the client {{clientName}}',
        fr: "Ajouter un contact pour l'adresse du client {{clientName}}",
        nl: 'Voeg een contact toe voor het adres van de klant {{clientName}}',
        es: 'Agregar un contacto para la dirección del cliente {{clientName}}',
    },
    modalContactTitle: {
        en: 'Add a new contact',
        fr: 'Ajouter un nouveau contact',
        nl: 'Een nieuw contact toevoegen',
        es: 'Agregar un nuevo contacto',
    },
    modalArticleTitle: {
        en: 'Add a new article',
        fr: 'Ajouter un nouvel article',
        nl: 'Voeg een nieuw artikel toe',
        es: 'Agregar un nuevo artículo',
    },
    modalEditArticleTitle: {
        en: 'Edit an article',
        fr: 'Modifier un article',
        nl: 'Een artikel bewerken',
        es: 'Editar un artículo',
    },
    modalEditComfourDataTitle: {
        en: 'Edit COMFOUR delivery information',
        fr: 'Modifier les informations de livraison COMFOUR',
        nl: 'COMFOUR-bezorgingsinformatie wijzigen',
        es: 'Editar la información de entrega COMFOUR',
    },
    modalComfourDataTitle: {
        en: 'Add Leroy Merlin order information',
        fr: 'Ajouter les informations de la commande Leroy Merlin',
        nl: 'Leroy Merlin bestelinformatie toevoegen',
        es: 'Agregar la información del pedido Leroy Merlin',
    },
    modalContactSubtitle: {
        en: 'Enter contact information',
        fr: 'Entrez les informations de contact',
        nl: 'Voer contactgegevens in',
        es: 'Introducir la información de contacto',
    },
    modalAddressSubtitle: {
        en: 'Enter address information',
        fr: "Saisir les informations de l'adresse",
        nl: 'Adresgegevens invoeren',
        es: 'Introducir la información de la dirección',
    },
    modalAddressSubtitleDelivery: {
        en: 'Enter the delivery address information',
        fr: "Saisir les informations de l'adresse de livraison",
        nl: 'Voer de gegevens van het afleveradres in',
        es: 'Introducir la información de la dirección de entrega',
    },
    modalAddressSubtitleComment: {
        en: 'Enter address instructions',
        fr: "Saisir les instructions de l'adresse",
        nl: 'Voer adresinstructies in',
        es: 'Introducir las instrucciones de la dirección',
    },
    modalAddressSubtitlePickup: {
        en: 'Enter the pickup address information',
        fr: "Saisir les informations de l'adresse de chargement",
        nl: 'Voer de gegevens van het ophaaladres in',
        es: 'Introducir la información de la dirección de recogida',
    },
    deleteDocument: {
        en: 'Delete the document',
        fr: 'Supprimer le document',
        nl: 'Verwijder document',
        es: 'Eliminar el documento',
    },
    deleteDocumentSub: {
        en: 'Are you sure you want to delete the document ? This action is definitive.',
        fr: 'Êtes-vous certains de vouloir supprimer le document ? Cette action est définitive.',
        nl: 'Weet u zeker dat u het document wilt verwijderen ? Deze actie is definitief.',
        es: '¿Está seguro de que desea eliminar el documento? Esta acción es definitiva.',
    },
    noResultFound: {
        en: 'No result found',
        fr: 'Aucun résultat trouvé',
        nl: 'Geen resultaat gevonden',
        es: 'No se han encontrado resultados',
    },
    pleaseDoASearch: {
        en: 'Please do a search',
        fr: 'Veuillez faire une recherche',
        nl: 'Voer een zoekopdracht uit',
        es: 'Por favor, realice una búsqueda',
    },
    createdThe: {
        en: 'Created on',
        fr: 'Créé le',
        nl: 'Gemaakt op',
        es: 'Creado el',
    },
    creation: {
        en: 'Creation',
        fr: 'Création',
        nl: 'Creatie',
        es: 'Creación',
    },
    createdBy: {
        en: 'Created by',
        fr: 'Créé par',
        nl: 'Gemaakt door',
        es: 'Creado por',
    },
    anErrorHasOccurred: {
        en: 'An error has occurred',
        fr: 'Une erreur est survenue',
        nl: 'Er is een fout opgetreden ',
        es: 'Ha ocurrido un error',
    },
    anErrorOccurred: {
        en: 'An error has occurred',
        fr: 'Une erreur est survenue',
        nl: 'Er is een fout opgetreden',
        es: 'Ha ocurrido un error',
    },
    error: {
        en: 'Error',
        fr: 'Erreur',
        nl: 'Fout',
        es: 'Error',
    },
    theElementHasBeenAdded: {
        en: 'The element has been added',
        fr: "L'élément a bien été ajouté",
        nl: 'Het element is toegevoegd',
        es: 'El elemento ha sido agregado',
    },
    theElementhasBeenDeleted: {
        en: 'The element has been deleted',
        fr: "L'élément a bien été supprimé",
        nl: 'Het element is verwijderd',
        es: 'El elemento ha sido eliminado',
    },
    theElementhasBeenCancelled: {
        en: 'The element has been cancelled',
        fr: "L'élément a bien été annulé",
        nl: 'Het item is geannuleerd',
        es: 'El elemento ha sido cancelado',
    },
    theElementhasBeenUpdated: {
        en: 'The element has been updated',
        fr: "L'élément a bien été mis à jour",
        nl: 'Het element is bijgewerkt',
        es: 'El elemento ha sido actualizado',
    },
    youAreNotAllowedToDoThisAction: {
        en: 'You are not allowed to do this action',
        fr: "Vous n'êtes pas autorisé à effectuer cette action",
        nl: 'U mag deze handeling niet uitvoeren',
        es: 'No está autorizado para realizar esta acción',
    },
    itemNotFound: {
        en: 'Item not found',
        fr: "L'élément n'a pas été trouvé",
        nl: 'Item niet gevonden',
        es: 'Elemento no encontrado',
    },
    content: {
        en: 'Goods',
        fr: 'Marchandises',
        nl: 'Goederen',
        es: 'Mercancías',
    },
    comments: {
        en: 'Comments',
        fr: 'Commentaires',
        nl: 'Opmerkingen',
        es: 'Comentarios',
    },
    merchandise: {
        en: 'Merchandise',
        fr: 'Marchandise',
        nl: 'Goederen',
        es: 'Mercancía',
    },
    toAddDocumentsYouMustFirstSaveYourOrder: {
        en: 'To add documents, you must first save your order',
        fr: "Pour ajouter des documents, vous devez d'abord enregistrer votre commande",
        nl: 'Om documenten toe te voegen, moet u uw bestelling eerst opslaan',
        es: 'Para agregar documentos, primero debe guardar su pedido',
    },
    administration: {
        en: 'Administration',
        fr: 'Administration',
        nl: 'Administratie',
        es: 'Administración',
    },
    users: {
        en: 'Users',
        fr: 'Utilisateurs',
        nl: 'Gebruikers',
        es: 'Usuarios',
    },
    user: {
        en: 'User',
        fr: 'Utilisateur',
        nl: 'Gebruiker',
        es: 'Usuario',
    },
    operatingCenters: {
        en: 'Exploitations',
        fr: 'Exploitations',
        nl: 'Exploitatiecentra',
        es: 'Centros operativos',
    },
    operatingCenter: {
        en: 'Exploitation',
        fr: 'Exploitation',
        nl: 'Exploitatiecentrum',
        es: 'Centro operativo',
    },
    clients: {
        en: 'Clients',
        fr: 'Clients',
        nl: 'Klanten',
        es: 'Clientes',
    },
    currentClient: {
        en: 'Current client',
        fr: 'Client actuel',
        nl: 'Huidige klant',
        es: 'Cliente actual',
    },
    client: {
        en: 'Client',
        fr: 'Client',
        nl: 'Klant',
        es: 'Cliente',
    },
    clientAccounts: {
        en: 'Client Accounts',
        fr: 'Comptes clients',
        nl: 'Klantaccounts',
        es: 'Cuentas de clientes',
    },
    clientAccount: {
        en: 'Client Account',
        fr: 'Compte client',
        nl: 'Klantaccount',
        es: 'Cuenta de cliente',
    },
    imagineCode: {
        en: 'Imagine code',
        fr: 'Code Imagine',
        nl: 'Imagine-code',
        es: 'Código Imagine',
    },
    tmsCode: {
        en: 'TMS code',
        fr: 'Code TMS',
        nl: 'TMS-code',
        es: 'Código TMS',
    },
    tmsCodeCenter: {
        en: 'TMS center code',
        fr: 'Code centre TMS',
        nl: 'TMS-centrumcode',
        es: 'Código de centro TMS',
    },
    tmsTypeCode: {
        en: 'TMS type code',
        fr: 'Code type TMS',
        nl: 'TMS-typecode',
        es: 'Código de tipo TMS',
    },
    email: {
        en: 'Email',
        fr: 'Email',
        nl: 'E-mail',
        es: 'Correo electrónico',
    },
    emails: {
        en: 'Emails',
        fr: 'Emails',
        nl: 'E-mails',
        es: 'Correos electrónicos',
    },
    password: {
        en: 'Password',
        fr: 'Mot de passe',
        nl: 'Wachtwoord',
        es: 'Contraseña',
    },
    confirmPassword: {
        en: 'Confirm password',
        fr: 'Confirmer mot de passe',
        nl: 'Bevestig wachtwoord',
        es: 'Confirmar contraseña',
    },
    memberOfMousset: {
        en: 'Member of the Mousset Group?',
        fr: 'Membre du Groupe Mousset ?',
        nl: 'Lid van de Mousset Groep?',
        es: '¿Miembro del Grupo Mousset?',
    },
    yourPasswordHasBeenReset: {
        en: 'Your password has been reset',
        fr: 'Votre mot de passe a bien été réinitialisé',
        nl: 'Je wachtwoord is gereset',
        es: 'Su contraseña ha sido restablecida',
    },
    signup: {
        en: 'Signup',
        fr: "S'inscrire",
        nl: 'Aanmelden',
        es: 'Registrarse',
    },
    passwordForgotten: {
        en: 'Password forgotten ?',
        fr: 'Mot de passe oublié ?',
        nl: 'Wachtwoord vergeten ?',
        es: '¿Contraseña olvidada?',
    },
    requestPassword: {
        en: 'Reset password',
        fr: 'Réinitialiser le mot de passe',
        nl: 'Wachtwoord opnieuw instellen',
        es: 'Restablecer contraseña',
    },
    requestPasswordSent: {
        en: 'If an account is associated with this address, you will receive a link to reset your password.',
        fr: 'Si un compte est associé à cette adresse, vous recevrez un lien pour réinitialiser votre mot de passe.',
        nl: 'Als er een account aan dit adres is gekoppeld, ontvangt u een link om uw wachtwoord opnieuw in te stellen.',
        es: 'Si hay una cuenta asociada a esta dirección, recibirá un enlace para restablecer su contraseña.',
    },
    roles: {
        en: 'Roles',
        fr: 'Rôles',
        nl: 'Rollen',
        es: 'Roles',
    },
    company: {
        en: 'Company',
        fr: 'Société',
        nl: 'Bedrijf',
        es: 'Empresa',
    },
    logo: {
        en: 'Logo',
        fr: 'Logo',
        nl: 'Logo',
        es: 'Logo',
    },
    companies: {
        en: 'Companies',
        fr: 'Sociétés',
        nl: 'Bedrijven',
        es: 'Empresas',
    },
    selectionOfACompany: {
        en: 'Selection of a company',
        fr: "Sélection d'une société",
        nl: 'Selectie van een bedrijf',
        es: 'Selección de una empresa',
    },
    references: {
        en: 'References',
        fr: 'Références',
        nl: 'Referenties',
        es: 'Referencias',
    },
    clientReference: {
        en: 'Client reference',
        fr: 'Référence client',
        nl: 'Klantreferentie',
        es: 'Referencia del cliente',
    },
    clientReferenceInfo: {
        en: 'Client reference',
        fr: 'Saisir la référence qui sera affichée sur la facture. Cette référence doit être unique et donc différente des dernières commandes.',
        nl: 'Voer de klantreferentie in voor de factuur.',
        es: 'Introduzca la referencia que aparecerá en la factura. Esta referencia debe ser única y diferente de los últimos pedidos.',
    },
    name: {
        en: 'Name',
        fr: 'Nom',
        nl: 'Naam',
        es: 'Nombre',
    },
    abbreviation: {
        en: 'Abbreviation',
        fr: 'Abréviation',
        nl: 'Afkorting',
        es: 'Abreviatura',
    },
    isComfourDataRequired: {
        en: 'Is Comfour data required ?',
        fr: 'Données Comfour requises ?',
        nl: 'Zijn Comfour-gegevens vereist ?',
        es: '¿Se requieren datos Comfour?',
    },
    isRdvRequired: {
        en: 'Is meeting required ?',
        fr: 'Rdv requis ?',
        nl: 'Is een afspraak vereist ?',
        es: '¿Se requiere cita?',
    },
    isOtNumberRequired: {
        en: 'Is OT number required ?',
        fr: 'Numéro OT requis ?',
        nl: 'Is OT-nummer vereist ?',
        es: '¿Se requiere número OT?',
    },
    deliveryTypes: {
        en: 'Delivery types',
        fr: 'Types de livraison',
        nl: 'Leveringstypes',
        es: 'Tipos de entrega',
    },
    deliveryConfirmed: {
        fr: 'Votre demande a été confirmée.',
        en: 'Your request has been confirmed.',
        nl: 'Uw verzoek is bevestigd.',
        es: 'Su solicitud ha sido confirmada.',
    },
    deliveryWaiting: {
        fr: "Votre demande est en attente d'envoi.",
        en: 'Your request is waiting to be sent.',
        nl: 'Uw verzoek wacht om te worden verzonden.',
        es: 'Su solicitud está esperando para ser enviada.',
    },
    deliverySent: {
        fr: 'Votre demande est en attente de confirmation.',
        en: 'Your request is waiting for confirmation.',
        nl: 'Uw verzoek wacht op bevestiging.',
        es: 'Su solicitud está esperando confirmación.',
    },
    deliveryNotConfirmed: {
        fr: "Votre demande n'a pas été confirmée",
        en: 'Your request has not been confirmed',
        nl: 'Uw verzoek is niet bevestigd',
        es: 'Su solicitud no ha sido confirmada',
    },
    clientCode: {
        en: 'Client code',
        fr: 'Code client',
        nl: 'Klantcode',
        es: 'Código de cliente',
    },
    isClientRisky: {
        en: 'Is the client at risk ?',
        fr: 'Le client est-il à risque ?',
        nl: 'Is de klant risicovol?',
        es: '¿El cliente es de riesgo?',
    },
    canCreateOrder: {
        en: 'Can create an order?',
        fr: 'Peut créer une commande ?',
        nl: 'Kan een bestelling aanmaken?',
        es: '¿Puede crear un pedido?',
    },
    isFootageInformable: {
        en: 'Is the footage informable ?',
        fr: 'Le métrage est-il renseignable ?',
        nl: 'Is de meterage invulbaar?',
        es: '¿Se puede informar el metraje?',
    },
    calcFootage: {
        en: 'Calc footage ?',
        fr: 'Calcul métrage ?',
        nl: 'Meterage berekenen?',
        es: '¿Calcular metraje?',
    },
    isOrderSendingEmailAutomatic: {
        en: 'Tracking link sent automatically?',
        fr: 'Lien de suivi envoyé automatiquement ?',
        nl: 'Trackinglink automatisch verzonden?',
        es: '¿Enlace de seguimiento enviado automáticamente?',
    },
    confirmationEmailEntry: {
        en: 'Confirmation Email Entry',
        fr: 'Confirmation Mail Saisie',
        nl: 'Bevestiging e-mailinvoer',
        es: 'Confirmación de entrada de correo',
    },
    labelFormat: {
        en: 'Default label format',
        fr: 'Format des étiquettes par défaut',
        nl: 'Standaard labelformaat',
        es: 'Formato de etiqueta predeterminado',
    },
    contractor: {
        en: 'Ordering party',
        fr: "Donneur d'ordre",
        nl: 'Opdrachtgever',
        es: 'Contratante',
    },
    refDo: {
        fr: 'REF DO',
        en: 'REF DO',
        nl: 'REF DO',
        es: 'REF DO',
    },
    firstname: {
        en: 'First name',
        fr: 'Prénom',
        nl: 'Voornaam',
        es: 'Nombre',
    },
    storeNumber: {
        en: 'Store number',
        fr: 'Numéro du magasin',
        nl: 'Winkelnummer',
        es: 'Número de tienda',
    },
    clientNumber: {
        en: 'Client number',
        fr: 'Numéro client',
        nl: 'Klantnummer',
        es: 'Número de cliente',
    },
    store: {
        en: 'Store',
        fr: 'Magasin',
        nl: 'Winkel',
        es: 'Tienda',
    },
    orderNumber: {
        en: 'Allegro number',
        fr: 'Numéro Allegro',
        nl: 'Allegro-nummer',
        es: 'Número Allegro',
    },
    lastname: {
        en: 'Last name',
        fr: 'Nom',
        nl: 'Achternaam',
        es: 'Apellido',
    },
    administrationEntry: {
        en: 'Administration entry',
        fr: 'Saisie administration',
        nl: 'Administratie-invoer',
        es: 'Entrada de administración',
    },
    allAdministrations: {
        en: 'All {{0}}',
        fr: 'Tous les {{0}}',
        nl: 'Alle {{0}}',
        es: 'Todos los {{0}}',
    },
    allClientAccounts: {
        en: 'Client accounts',
        fr: 'Comptes clients',
        nl: 'Klantaccounts',
        es: 'Cuentas de clientes',
    },
    profiles: {
        en: 'Profiles',
        fr: 'Profils',
        nl: 'Profielen',
        es: 'Perfiles',
    },
    profile: {
        en: 'Profile',
        fr: 'Profil',
        nl: 'Profiel',
        es: 'Perfil',
    },
    addressType: {
        en: 'Address type',
        fr: "Type d'adresse",
        nl: 'Adrestype',
        es: 'Tipo de dirección',
    },
    modalDeleteElementTitle: {
        en: 'Delete {{0}}',
        fr: 'Supprimer {{0}}',
        nl: 'Verwijder {{0}}',
        es: 'Eliminar {{0}}',
    },
    modalDeleteElementSubtitle: {
        en: 'Are you sure you want to delete the {{0}} ? This action is definitive.',
        fr: 'Êtes-vous certains de vouloir supprimer le/la {{0}} ? Cette action est définitive.',
        nl: 'Weet u zeker dat u {{0}} wilt verwijderen? Deze actie is definitief.',
        es: '¿Está seguro de que desea eliminar {{0}}? Esta acción es definitiva.',
    },
    modalDeleteElementTitleAddress: {
        en: 'Delete address',
        fr: 'Supprimer cette adresse',
        nl: 'Dit adres verwijderen',
        es: 'Eliminar esta dirección',
    },
    modalDeleteElementSubtitleAddress: {
        en: 'Are you sure you want to delete this address ? This action is definitive.',
        fr: 'Êtes-vous certains de vouloir supprimer cette adresse ? Cette action est définitive.',
        nl: 'Weet je zeker dat je dit adres wilt verwijderen? Deze actie is definitief.',
        es: '¿Está seguro de que desea eliminar esta dirección? Esta acción es definitiva.',
    },
    fields: {
        en: 'Fields',
        fr: 'Champs',
        nl: 'Velden',
        es: 'Campos',
    },
    information: {
        en: 'Information',
        fr: 'Informations',
        nl: 'Informatie',
        es: 'Información',
    },
    addresses: {
        en: 'Addresses',
        fr: 'Adresses',
        nl: 'Adressen',
        es: 'Direcciones',
    },
    addressesToBeValidated: {
        en: 'Addresses to be validated',
        fr: 'Adresses à valider',
        nl: 'Te valideren adressen',
        es: 'Direcciones para validar',
    },
    departments: {
        en: 'Departments',
        fr: 'Départements',
        nl: 'Afdelingen',
        es: 'Departamentos',
    },
    department: {
        en: 'Department',
        fr: 'Département',
        nl: 'Afdeling',
        es: 'Departamento',
    },
    platform: {
        en: 'Platform',
        fr: 'Plateforme',
        nl: 'Platform',
        es: 'Plataforma',
    },
    platforms: {
        en: 'Platforms',
        fr: 'Plateformes',
        nl: 'Platforms',
        es: 'Plataformas',
    },
    address: {
        en: 'Address',
        fr: 'Adresse',
        nl: 'Adres',
        es: 'Dirección',
    },
    clientAddress: {
        fr: 'Adresse du client',
        en: 'Client address',
        nl: 'Klantadres',
        es: 'Dirección del cliente',
    },
    deliveryAddresses: {
        en: 'Delivery addresses',
        fr: 'Adresses de livraison',
        nl: 'Afleveradressen',
        es: 'Direcciones de entrega',
    },
    pickupAddresses: {
        en: 'Pickup addresses',
        fr: "Adresses d'enlèvement",
        nl: 'Ophaaladressen',
        es: 'Direcciones de recogida',
    },
    registrationNumber: {
        en: 'Registration number',
        fr: 'Matricule',
        nl: 'Registratienummer',
        es: 'Matrícula',
    },
    validatedClient: {
        en: 'Client validation',
        fr: 'Validation client',
        nl: 'Klantvalidatie',
        es: 'Validación de cliente',
    },
    validatedCommand: {
        en: 'Company validation',
        fr: 'Validation société',
        nl: 'Bedrijfsvalidatie',
        es: 'Validación de empresa',
    },
    validatedAddressPickup: {
        en: 'Pickup address',
        fr: "Adresse d'enlèvement",
        nl: 'Ophaaladres',
        es: 'Dirección de recogida',
    },
    validatedAddressDelivery: {
        en: 'Delivery address',
        fr: 'Adresse de livraison',
        nl: 'Bezorgadres',
        es: 'Dirección de entrega',
    },
    pleaseSelectACompanyFirst: {
        en: 'Please select a company first',
        fr: 'Veuillez sélectionner une société en premier',
        nl: 'Selecteer eerst een bedrijf',
        es: 'Por favor, seleccione una empresa primero',
    },
    orderHasBeenAdded: {
        en: 'The order has been successfully added. Once the documents have been added, remember to validate the order.',
        fr: 'La commande a bien été ajoutée. Une fois les documents renseignés, pensez à valider la commande.',
        nl: 'De bestelling is succesvol toegevoegd. Vergeet niet om de bestelling te valideren zodra de documenten zijn toegevoegd.',
        es: 'El pedido ha sido agregado con éxito. Una vez agregados los documentos, recuerde validar el pedido.',
    },
    rejected: {
        en: 'Rejected',
        fr: 'Rejeté',
        nl: 'Afgewezen',
        es: 'Rechazado',
    },
    orderRejectedBannerText: {
        en: 'An error has occurred, please contact the {{companyName}} teams at the following email address: {{mail}}.',
        fr: "Une erreur s'est produite, merci de contacter les équipes {{companyName}} à l'adresse mail suivante : {{mail}}.",
        nl: 'Er is een fout opgetreden, neem contact op met het {{companyName}}-team via het volgende e-mailadres: {{mail}}.',
        es: 'Ha ocurrido un error, por favor contacte con el equipo de {{companyName}} en la siguiente dirección de correo: {{mail}}.',
    },
    startTime: {
        en: 'Start time',
        fr: 'Horaire de début',
        nl: 'Starttijd',
        es: 'Hora de inicio',
    },
    endTime: {
        en: 'End time',
        fr: 'Horaire de fin',
        nl: 'Eindtijd',
        es: 'Hora de fin',
    },
    dates: {
        en: 'Dates',
        fr: 'Dates',
        nl: 'Datums',
        es: 'Fechas',
    },
    date: {
        en: 'Date',
        fr: 'Date',
        nl: 'Datum',
        es: 'Fecha',
    },
    dateFormat: {
        en: 'dd/mm/yyyy',
        fr: 'jj/mm/aaaa',
        nl: 'dd/mm/jjjj',
        es: 'dd/mm/aaaa',
    },
    pickupDate: {
        en: 'Pickup date',
        fr: "Date d'enlèvement",
        nl: 'Ophaaldatum',
        es: 'Fecha de recogida',
    },
    endPickupDate: {
        en: 'End pickup date',
        fr: 'Date de fin de chargement',
        nl: 'Einddatum laden',
        es: 'Fecha de fin de recogida',
    },
    pickupDateHour: {
        en: 'Start pickup hour',
        fr: "Début d'heure de chargement",
        nl: 'Starttijd laden',
        es: 'Hora de inicio de recogida',
    },
    endPickupDateHour: {
        en: 'End pickup hour',
        fr: "Fin d'heure de chargement",
        nl: 'Eindtijd laden',
        es: 'Hora de fin de recogida',
    },
    deliveryDateHour: {
        en: 'Start delivery hour',
        fr: "Début d'heure de livraison",
        nl: 'Starttijd levering',
        es: 'Hora de inicio de entrega',
    },
    endDeliveryDateHour: {
        en: 'End delivery hour',
        fr: "Fin d'heure de livraison",
        nl: 'Eindtijd levering',
        es: 'Hora de fin de entrega',
    },
    deliveryDate: {
        en: 'Delivery date',
        fr: 'Date de livraison',
        nl: 'Leveringsdatum',
        es: 'Fecha de entrega',
    },
    deliveryDateEnd: {
        en: 'End delivery date',
        fr: 'Date de fin de livraison',
        nl: 'Einddatum levering',
        es: 'Fecha de fin de entrega',
    },
    startDeliveryDate: {
        en: 'Start delivery date',
        fr: 'Date début livraison',
        nl: 'Startdatum levering',
        es: 'Fecha de inicio de entrega',
    },
    endDeliveryDate: {
        en: 'End delivery date',
        fr: 'Date de fin de livraison',
        nl: 'Einddatum levering',
        es: 'Fecha de fin de entrega',
    },
    timeDeliveryDate: {
        en: 'Estimated delivery time',
        fr: 'Temps de livraison estimé',
        nl: 'Geschatte levertijd',
        es: 'Tiempo de entrega estimado',
    },
    estimated: {
        en: 'Estimated',
        fr: 'Estimé',
        nl: 'Geschat',
        es: 'Estimado',
    },
    picked: {
        en: 'Picked',
        fr: 'Enlevé',
        nl: 'Opgehaald',
        es: 'Recogido',
    },
    timePickupDate: {
        en: 'Estimated pickup time',
        fr: 'Temps de chargement estimé',
        nl: 'Geschatte laadtijd',
        es: 'Tiempo de recogida estimado',
    },
    pleaseAddTheFile: {
        en: 'Please add the file "{{0}}".',
        fr: 'Veuillez ajouter le fichier "{{0}}".',
        nl: 'Voeg het bestand "{{0}}" toe.',
        es: 'Por favor, añada el archivo "{{0}}".',
    },
    addFileOptionnal: {
        en: 'The file "{{0}}" is optional.',
        fr: 'Le fichier "{{0}}" est optionnel.',
        nl: 'Het bestand "{{0}}" is optioneel.',
        es: 'El archivo "{{0}}" es opcional.',
    },
    type: {
        en: 'Type',
        fr: 'Type',
        nl: 'Type',
        es: 'Tipo',
    },
    noFileFound: {
        en: 'No file found',
        fr: 'Aucun fichier trouvé',
        nl: 'Geen bestanden gevonden',
        es: 'No se encontraron archivos',
    },
    dragYourDocument: {
        en: 'Drag your document',
        fr: 'Glissez votre document',
        nl: 'Sleep uw document',
        es: 'Arrastre su documento',
    },
    or: {
        en: 'or',
        fr: 'ou',
        nl: 'of',
        es: 'o',
    },
    clickHere: {
        en: 'click here',
        fr: 'cliquer ici',
        nl: 'klik hier',
        es: 'haga clic aquí',
    },
    toSelectAFile: {
        en: 'to select a file',
        fr: 'pour sélectionner un fichier',
        nl: 'om een bestand te selecteren',
        es: 'para seleccionar un archivo',
    },
    documentType: {
        en: 'Document type',
        fr: 'Type de document',
        nl: 'Documenttype',
        es: 'Tipo de documento',
    },
    nameEn: {
        en: 'Name (en)',
        fr: 'Nom (en)',
        nl: 'Naam (en)',
        es: 'Nombre (en)',
    },
    nameFr: {
        en: 'Name (fr)',
        fr: 'Nom (fr)',
        nl: 'Naam (fr)',
        es: 'Nombre (fr)',
    },
    nameNl: {
        en: 'Name (nl)',
        fr: 'Nom (nl)',
        nl: 'Naam (nl)',
        es: 'Nombre (nl)',
    },
    nameEs: {
        en: 'Name (es)',
        fr: 'Nom (es)',
        nl: 'Naam (es)',
        es: 'Nombre (es)',
    },
    countries: {
        en: 'Countries',
        fr: 'Pays',
        nl: 'Landen',
        es: 'Países',
    },
    countriesMandatory: {
        en: 'Mandatory countries',
        fr: 'Pays obligatoires',
        nl: 'Verplichte landen',
        es: 'Países obligatorios',
    },
    countriesOptionnal: {
        en: 'Optional countries',
        fr: 'Pays optionnels',
        nl: 'Optionele landen',
        es: 'Países opcionales',
    },
    fileToView: {
        en: 'File to view',
        fr: 'Fichier à consulter',
        nl: 'Bestand bekijken',
        es: 'Archivo para consultar',
    },
    fileSettings: {
        en: 'File settings',
        fr: 'Paramètres des fichiers',
        nl: 'Bestandsinstellingen',
        es: 'Configuración de archivos',
    },
    activityCodes: {
        en: 'Activity codes',
        fr: 'Codes d’activité',
        nl: 'Activiteitscodes',
        es: 'Códigos de actividad',
    },
    activityCode: {
        en: 'Activity code',
        fr: 'Code d’activité',
        nl: 'Activiteitscode',
        es: 'Código de actividad',
    },
    fileSetting: {
        en: 'File setting',
        fr: 'Param. du fichier',
        nl: 'Bestandsinstelling',
        es: 'Configuración de archivo',
    },
    fileNotRequired: {
        en: 'File not required',
        fr: 'Fichier non requis',
        nl: 'Bestand niet vereist',
        es: 'Archivo no requerido',
    },
    docRequiredForCountry: {
        en: 'The document will be mandatory on orders with the country of delivery or pick-up in the countries selected',
        fr: 'Le document sera obligatoire sur les commandes ayant le pays de livraison ou de ramassage dans les pays sélectionnés',
        nl: 'Het document is verplicht bij bestellingen met het land van levering of afhaling in de geselecteerde landen',
        es: 'El documento será obligatorio en los pedidos con el país de entrega o recogida en los países seleccionados',
    },
    docOptionnalForCountry: {
        en: 'The document will be optional on orders with the country of delivery or pick-up in the countries selected',
        fr: 'Le document sera optionnel sur les commandes ayant le pays de livraison ou de ramassage dans les pays sélectionnés',
        nl: 'Het document is optioneel voor bestellingen met het land van levering of afhaling in de geselecteerde landen',
        es: 'El documento será opcional en los pedidos con el país de entrega o recogida en los países seleccionados',
    },
    commentOrderInfo: {
        en: 'This comment will be displayed on the CMR. (Example: Supplier name)',
        fr: 'Ce commentaire sera affiché sur la CMR. (Exemple : Nom du Fournisseur)',
        nl: 'Deze opmerking wordt weergegeven op de CMR. (Voorbeeld: Leveranciersnaam)',
        es: 'Este comentario se mostrará en el CMR. (Ejemplo: Nombre del proveedor)',
    },
    thisAddressMustBeVerified: {
        en: 'This address must be verified by the company before validating the order.',
        fr: 'Cette adresse doit être vérifiée par la société avant validation de la commande.',
        nl: 'Dit adres moet door het bedrijf worden geverifieerd voordat de bestelling wordt gevalideerd.',
        es: 'Esta dirección debe ser verificada por la empresa antes de validar el pedido.',
    },
    thisAddressisSurtaxed: {
        en: 'This address is surtaxed.',
        fr: 'Cette adresse est surtaxée.',
        nl: 'Dit adres is belast met een toeslag.',
        es: 'Esta dirección tiene un recargo.',
    },
    editInstructions: {
        en: 'Edit instructions',
        fr: 'Modifier les instructions',
        nl: 'Instructies bewerken',
        es: 'Editar instrucciones',
    },
    timeOrder: {
        en: 'Time for order',
        fr: 'Heure pour commande',
        nl: 'Tijd voor bestelling',
        es: 'Hora para pedido',
    },
    yourOrderMustBePlacedBefore: {
        en: 'Your order must be placed before <b>{{0}}</b> (excluding weekends and holidays) if you want it to be picked up the next day.',
        fr: "Votre commande doit être passée avant <b>{{0}}</b> (hors week-ends et jours fériés) si vous voulez qu'elle soit ramassée le jour suivant.",
        nl: 'Uw bestelling moet vóór <b>{{0}}</b> (exclusief weekends en feestdagen) worden geplaatst als u wilt dat deze de volgende dag wordt opgehaald.',
        es: 'Su pedido debe realizarse antes de las <b>{{0}}</b> (excluyendo fines de semana y festivos) si desea que se recoja al día siguiente.',
    },
    warningFile: {
        en: 'The packing list is mandatory for the completion of your transport order. Please attach it to your transport request and put it on the pallet(s) of your merchandise.',
        fr: 'Le bon de livraison est obligatoire pour la réalisation de votre ordre de transport. Veuillez le joindre à votre demande de transport et le mettre sur la ou les palettes de votre marchandise.',
        nl: 'De pakbon is verplicht voor het afronden van uw transportopdracht. Gelieve deze bij uw transportaanvraag te voegen en op de pallet(s) van uw goederen te plaatsen.',
        es: 'El albarán es obligatorio para la realización de su orden de transporte. Por favor, adjúntelo a su solicitud de transporte y colóquelo en los palés de su mercancía.',
    },
    amountInsurrance: {
        en: 'Amount to cover',
        fr: 'Montant à couvrir',
        nl: 'Te dekken bedrag',
        es: 'Cantidad a cubrir',
    },
    labelAddress: {
        en: 'Address name',
        fr: "Nom de l'adresse",
        nl: 'Adresnaam',
        es: 'Nombre de la dirección',
    },
    phoneNumber: {
        en: 'Phone number',
        fr: 'Numéro de téléphone',
        nl: 'Telefoonnummer',
        es: 'Número de teléfono',
    },
    phoneNumber2: {
        en: 'Other phone number',
        fr: 'Autre numéro de téléphone',
        nl: 'Ander telefoonnummer',
        es: 'Otro número de teléfono',
    },
    pleaseEnterYourLogo: {
        en: 'Please add your company logo',
        fr: 'Veuillez ajouter le logo de votre société',
        nl: 'Voeg het logo van uw bedrijf toe',
        es: 'Por favor, añada el logotipo de su empresa',
    },
    whyEnterYourLogo: {
        en: 'Your company logo will be displayed on the portal as well as on the various transport documents.',
        fr: 'Le logo de votre société sera affiché sur le portail ainsi que sur les différents documents de transport.',
        nl: 'Het logo van uw bedrijf wordt weergegeven op het portaal en op de verschillende transportdocumenten.',
        es: 'El logotipo de su empresa se mostrará en el portal y en los diversos documentos de transporte.',
    },
    pleaseEnterYourPhoneNumber: {
        en: 'Please enter your personal information',
        fr: 'Veuillez renseigner vos informations personnelles',
        nl: 'Voer uw persoonlijke gegevens in',
        es: 'Por favor, introduzca su información personal',
    },
    addLater: {
        en: 'Add later',
        fr: 'Ajouter plus tard',
        nl: 'Later toevoegen',
        es: 'Añadir más tarde',
    },
    inOrderPleaseSpecifyInformationBelow: {
        en: 'In order to be able to contact you in case of problems, please specify the information below:',
        fr: 'Afin de pouvoir vous contacter en cas de problèmes, veuillez préciser les informations ci-dessous :',
        nl: 'Om bij problemen contact met u op te kunnen nemen, verzoeken wij u onderstaande gegevens te vermelden:',
        es: 'Para poder contactar con usted en caso de problemas, especifique la información a continuación:',
    },
    deliveryClientReference: {
        en: 'Delivery Client Ref',
        fr: 'Livraison Réf Client',
        nl: 'Levering klantreferentie',
        es: 'Ref. cliente entrega',
    },
    pickupClientReference: {
        en: 'Pickup Client Ref',
        fr: 'Chargement Réf Client',
        nl: 'Laadreferentie klant',
        es: 'Ref. cliente recogida',
    },
    theElementhasBeenDuplicated: {
        en: 'The element has been duplicated',
        fr: "L'élément a bien été dupliqué",
        nl: 'Het element is gedupliceerd',
        es: 'El elemento ha sido duplicado',
    },
    duplicate: {
        en: 'Duplicate',
        fr: 'Dupliquer',
        nl: 'Dupliceren',
        es: 'Duplicar',
    },
    doYouWantToCreateANewOrderFromTheDataOfThisOne: {
        en: 'Do you want to create a new order from the data of this one?',
        fr: 'Voulez-vous créer une nouvelle commande à partir des données de celle-ci ?',
        nl: 'Wilt u een nieuwe bestelling aanmaken op basis van de gegevens van deze?',
        es: '¿Desea crear un nuevo pedido a partir de los datos de este?',
    },
    complementAddress: {
        en: 'Complement address',
        fr: "Complément d'adresse",
        nl: 'Adresaanvulling',
        es: 'Complemento de dirección',
    },
    complementAddressTooltip: {
        fr: "Le complément d'information permet de préciser l'adresse (Ex : Étage, n° de bâtiment...).",
        en: 'The complement of information allows to specify the address (Ex: Floor, Building number...).',
        nl: 'De aanvullende informatie maakt het mogelijk het adres te specificeren (bijv. verdieping, gebouwnummer...).',
        es: 'El complemento de información permite especificar la dirección (Ej: Piso, número de edificio...).',
    },
    warning: {
        en: 'Warning',
        fr: 'Attention',
        nl: 'Waarschuwing',
        es: 'Advertencia',
    },
    search: {
        en: 'Search',
        fr: 'Recherche',
        nl: 'Zoeken',
        es: 'Buscar',
    },
    reset: {
        en: 'Reset filters',
        fr: 'Réinitialiser les filtres',
        nl: 'Filters resetten',
        es: 'Restablecer filtros',
    },
    searchAddresses: {
        en: 'Filter addresses',
        fr: 'Filtrer les adresses',
        nl: 'Adressen filteren',
        es: 'Filtrar direcciones',
    },
    time: {
        en: 'Time',
        fr: 'Délai',
        nl: 'Tijd',
        es: 'Tiempo',
    },
    d: {
        en: 'D',
        fr: 'J',
        nl: 'D',
        es: 'D',
    },
    pickupDay: {
        en: 'Pickup day',
        fr: 'Jour de chargement',
        nl: 'Ophaaldag',
        es: 'Día de recogida',
    },
    deliveryDay: {
        en: 'Delivery day',
        fr: 'Jour de livraison',
        nl: 'Leveringsdag',
        es: 'Día de entrega',
    },
    deliveryZone: {
        en: 'Delivery zone',
        fr: 'Zone de livraison',
        nl: 'Leveringszone',
        es: 'Zona de entrega',
    },
    pickupZone: {
        en: 'Pickup zone',
        fr: 'Zone de chargement',
        nl: 'Ophaalzone',
        es: 'Zona de recogida',
    },
    mondayShort: {
        en: 'Mon',
        fr: 'Lun',
        nl: 'Ma',
        es: 'Lun',
    },
    tuesdayShort: {
        en: 'Tue',
        fr: 'Mar',
        nl: 'Di',
        es: 'Mar',
    },
    wednesdayShort: {
        en: 'Wed',
        fr: 'Mer',
        nl: 'Wo',
        es: 'Mié',
    },
    thursdayShort: {
        en: 'Thu',
        fr: 'Jeu',
        nl: 'Do',
        es: 'Jue',
    },
    fridayShort: {
        en: 'Fri',
        fr: 'Ven',
        nl: 'Vr',
        es: 'Vie',
    },
    saturdayShort: {
        en: 'Sat',
        fr: 'Sam',
        nl: 'Za',
        es: 'Sáb',
    },
    sundayShort: {
        en: 'Sun',
        fr: 'Dim',
        nl: 'Zo',
        es: 'Dom',
    },
    monday: {
        en: 'Monday',
        fr: 'Lundi',
        nl: 'Maandag',
        es: 'Lunes',
    },
    tuesday: {
        en: 'Tuesday',
        fr: 'Mardi',
        nl: 'Dinsdag',
        es: 'Martes',
    },
    wednesday: {
        en: 'Wednesday',
        fr: 'Mercredi',
        nl: 'Woensdag',
        es: 'Miércoles',
    },
    thursday: {
        en: 'Thursday',
        fr: 'Jeudi',
        nl: 'Donderdag',
        es: 'Jueves',
    },
    friday: {
        en: 'Friday',
        fr: 'Vendredi',
        nl: 'Vrijdag',
        es: 'Viernes',
    },
    saturday: {
        en: 'Saturday',
        fr: 'Samedi',
        nl: 'Zaterdag',
        es: 'Sábado',
    },
    sunday: {
        en: 'Sunday',
        fr: 'Dimanche',
        nl: 'Zondag',
        es: 'Domingo',
    },
    weCannotGuaranteeThisAddress: {
        en: 'Your address is not supported by our transportation plan. Please contact the JETFREEZE sales department to place your order: <b>jetfreeze@jetransporte.com</b>.',
        fr: "Votre adresse n'est pas prise en charge par notre plan de transport. Merci de contacter le service commercial JETFREEZE pour réaliser votre commande : <b>jetfreeze@jetransporte.com</b>.",
        nl: 'Uw adres wordt niet ondersteund door ons transportplan. Neem contact op met de verkoopafdeling van JETFREEZE om uw bestelling te plaatsen: <b>jetfreeze@jetransporte.com</b>.',
        es: 'Su dirección no está soportada por nuestro plan de transporte. Por favor, contacte con el departamento de ventas de JETFREEZE para realizar su pedido: <b>jetfreeze@jetransporte.com</b>.',
    },
    filesNotPossessed: {
        en: 'If you do not currently have the documents, please check this box.',
        fr: 'Si vous ne possédez pas actuellement les documents, merci de cocher cette case.',
        nl: 'Als u momenteel niet over de documenten beschikt, vink dan dit vakje aan.',
        es: 'Si no tiene los documentos actualmente, marque esta casilla.',
    },
    provideFilesLater: {
        en: 'You will have to send them by email later.',
        fr: 'Vous aurez à les communiquer par e-mails plus tard.',
        nl: 'U moet ze later per e-mail doorsturen.',
        es: 'Tendrá que enviarlos por correo electrónico más tarde.',
    },
    noFilesNowInfo: {
        en: "When you have the documents, don't forget to send them to the following email addresses : {{0}} / {{1}}",
        fr: "Lorsque vous serez en possession des documents, n'oubliez pas de les envoyer aux adresses e-mails suivantes : {{0}} / {{1}}",
        nl: 'Als u de documenten heeft, vergeet ze dan niet naar de volgende e-mailadressen te sturen : {{0}} / {{1}}',
        es: 'Cuando tenga los documentos, no olvide enviarlos a las siguientes direcciones: {{0}} / {{1}}',
    },
    suggestedAddresses: {
        en: 'Find an address',
        fr: 'Rechercher une adresse',
        nl: 'Zoek een adres',
        es: 'Buscar una dirección',
    },
    isSurtaxed: {
        en: 'Is this address surtaxed ?',
        fr: 'Cette adresse est-elle surtaxée ?',
        nl: 'Wordt er een toeslag geheven op dit adres?',
        es: '¿Esta dirección tiene recargo?',
    },
    instructions: {
        en: 'Instructions',
        fr: 'Instructions',
        nl: 'Instructies',
        es: 'Instrucciones',
    },
    other: {
        en: 'Other',
        fr: 'Autre',
        nl: 'Ander',
        es: 'Otro',
    },
    refresh: {
        en: 'Refresh',
        fr: 'Rafraîchir',
        nl: 'Vernieuwen',
        es: 'Refrescar',
    },
    logout: {
        en: 'Logout',
        fr: 'Se déconnecter',
        nl: 'Uitloggen',
        es: 'Cerrar sesión',
    },
    articleReferences: {
        fr: 'Références marchandises',
        en: 'Article references',
        nl: 'Artikelreferenties',
        es: 'Referencias de mercancía',
    },
    defaultDeliveryType: {
        en: 'Default delivery type',
        fr: 'Type de livraison par défaut',
        nl: 'Standaard leveringstype',
        es: 'Tipo de entrega predeterminado',
    },
    defaultAccessibility: {
        en: 'Default accessibility',
        fr: 'Accessibilité par défaut',
        nl: 'Standaard toegankelijkheid',
        es: 'Accesibilidad predeterminada',
    },
    defaultVehicleEquipment: {
        en: 'Default vehicle equipment',
        fr: 'Équipement du véhicule par défaut',
        nl: 'Standaarduitrusting van het voertuig',
        es: 'Equipamiento predeterminado del vehículo',
    },
    transports: {
        en: 'Transports',
        fr: 'Transports',
        nl: 'Transporten',
        es: 'Transportes',
    },
    allMyTransports: {
        en: 'All my transports',
        fr: 'Tous mes transports',
        nl: 'Al mijn transporten',
        es: 'Todos mis transportes',
    },
    waitingForValidation: {
        en: 'Waiting for validation',
        fr: 'Attente de validation',
        nl: 'Wachten op validatie',
        es: 'Esperando validación',
    },
    refused: {
        fr: 'Annulés',
        en: 'Cancelled',
        nl: 'Geannuleerd',
        es: 'Cancelados',
    },
    inProgress: {
        en: 'In progress',
        fr: 'En cours',
        nl: 'In behandeling',
        es: 'En curso',
    },
    completed: {
        fr: 'Livrés',
        en: 'Delivered',
        nl: 'Geleverd',
        es: 'Entregados',
    },
    orderEntry: {
        en: 'Transports',
        fr: 'Transports',
        nl: 'Transportopdrachten',
        es: 'Transportes',
    },
    orderEntryFull: {
        en: 'Enter transport order(s)',
        fr: 'Saisie commande(s) transport',
        nl: 'Voer transportopdracht(en) in',
        es: 'Entrada de orden(es) de transporte',
    },
    contacts: {
        en: 'Contacts',
        fr: 'Contacts',
        nl: 'Contactpersonen',
        es: 'Contactos',
    },
    tools: {
        en: 'Tools',
        fr: 'Outils',
        nl: 'Hulpmiddelen',
        es: 'Herramientas',
    },
    userEntry: {
        en: 'User entry',
        fr: 'Saisie utilisateur',
        nl: 'Gebruikersinvoer',
        es: 'Entrada de usuario',
    },
    allTheUsers: {
        en: 'All the users',
        fr: 'Tous les utilisateurs',
        nl: 'Alle gebruikers',
        es: 'Todos los usuarios',
    },
    edit: {
        en: 'Edit',
        fr: 'Modifier',
        nl: 'Bewerken',
        es: 'Editar',
    },
    editDelivery: {
        en: 'Edit delivery',
        fr: 'Modifier la livraison',
        nl: 'Levering bewerken',
        es: 'Editar entrega',
    },
    editPickup: {
        en: 'Edit pickup',
        fr: "Modifier l'enlèvement",
        nl: 'Afhaling bewerken',
        es: 'Editar recogida',
    },
    deleteUser: {
        en: 'Delete user',
        fr: "Supprimer l'utilisateur",
        nl: 'Gebruiker verwijderen',
        es: 'Eliminar usuario',
    },
    sureDeleteUser: {
        en: 'Are you sure you want to delete the user? This action is final.',
        fr: "Êtes-vous certain de vouloir supprimer l'utilisateur ? Cette action est définitive.",
        nl: 'Weet u zeker dat u de gebruiker wilt verwijderen? Deze actie is definitief.',
        es: '¿Está seguro de que desea eliminar al usuario? Esta acción es definitiva.',
    },
    clientEntry: {
        en: 'Client entry',
        fr: 'Saisie client',
        nl: 'Klantinvoer',
        es: 'Entrada de cliente',
    },
    allTheClients: {
        en: 'All the clients',
        fr: 'Tous les clients',
        nl: 'Alle klanten',
        es: 'Todos los clientes',
    },
    priceList: {
        en: 'Price list',
        fr: 'Grille tarifaire',
        nl: 'Prijslijst',
        es: 'Lista de precios',
    },
    code: {
        en: 'Code',
        fr: 'Code',
        nl: 'Code',
        es: 'Código',
    },
    deleteClient: {
        en: 'Delete client',
        fr: 'Supprimer le client',
        nl: 'Klant verwijderen',
        es: 'Eliminar cliente',
    },
    sureDeleteClient: {
        en: 'Are you sure you want to delete the client? This action is final.',
        fr: 'Êtes-vous certain de vouloir supprimer le client ? Cette action est définitive.',
        nl: 'Weet u zeker dat u de klant wilt verwijderen? Deze actie is definitief.',
        es: '¿Está seguro de que desea eliminar al cliente? Esta acción es definitiva.',
    },
    deleteLogisticConstraint: {
        en: 'Delete {{name}}',
        fr: 'Supprimer {{name}}',
        nl: 'Verwijder {{name}}',
        es: 'Eliminar {{name}}',
    },
    sureDeleteLogisticConstraint: {
        en: 'Are you sure you want to delete the logistic constraint? This action is final.',
        fr: 'Êtes-vous certain de vouloir supprimer la contrainte logistique ? Cette action est définitive.',
        nl: 'Weet u zeker dat u de logistieke beperking wilt verwijderen? Deze actie is definitief.',
        es: '¿Está seguro de que desea eliminar la restricción logística? Esta acción es definitiva.',
    },
    sureDeleteDeliveryType: {
        en: 'Are you sure you want to delete the delivery type? This action is final.',
        fr: 'Êtes-vous certain de vouloir supprimer le type de livraison ? Cette action est définitive.',
        nl: 'Weet u zeker dat u het leveringstype wilt verwijderen? Deze actie is definitief.',
        es: '¿Está seguro de que desea eliminar el tipo de entrega? Esta acción es definitiva.',
    },
    companyEntry: {
        en: 'Company entry',
        fr: 'Saisie société',
        nl: 'Bedrijfsinvoer',
        es: 'Entrada de empresa',
    },
    allTheCompanies: {
        en: 'All the companies',
        fr: 'Toutes les sociétés',
        nl: 'Alle bedrijven',
        es: 'Todas las empresas',
    },
    exportFileFormat: {
        en: 'Export file format',
        fr: "Format de fichier d'exportation",
        nl: 'Bestandsformaat exporteren',
        es: 'Formato de archivo de exportación',
    },
    areAddressTimeSlotsMandatory: {
        en: 'Are address time slots mandatory ?',
        fr: 'Les créneaux horaires des adresses sont-ils obligatoires ?',
        nl: 'Zijn de tijdslots van adressen verplicht?',
        es: '¿Son obligatorias las franjas horarias de las direcciones?',
    },
    hasDefaultMandatoryDeliveryDate: {
        en: 'Is the mandatory delivery date calculated by default?',
        fr: 'La date de livraison impérative se calcule par défaut ?',
        nl: 'Wordt de verplichte leverdatum standaard berekend?',
        es: '¿La fecha de entrega obligatoria se calcula por defecto?',
    },
    useCodeCenters: {
        en: 'Use of center codes?',
        fr: 'Utilisation des codes centres ?',
        nl: 'Gebruik van centrumcodes?',
        es: '¿Uso de los códigos de centro?',
    },
    isOperationCenterRequired: {
        en: 'Does the company use operation centers ?',
        fr: "La société utilise-t-elle des centres d'opérations ?",
        nl: 'Gebruikt het bedrijf exploitatiecentra?',
        es: '¿Utiliza la empresa centros de operaciones?',
    },
    deleteCompany: {
        en: 'Delete company',
        fr: 'Supprimer la société',
        nl: 'Bedrijf verwijderen',
        es: 'Eliminar empresa',
    },
    someFilesAreMissing: {
        en: 'Some files are missing',
        fr: 'Certains fichiers sont manquants',
        nl: 'Sommige bestanden ontbreken',
        es: 'Faltan algunos archivos',
    },
    sureDeleteCompany: {
        en: 'Are you sure you want to delete the company? This action is final.',
        fr: 'Êtes-vous certain de vouloir supprimer la société ? Cette action est définitive.',
        nl: 'Weet u zeker dat u het bedrijf wilt verwijderen? Deze actie is definitief.',
        es: '¿Está seguro de que desea eliminar la empresa? Esta acción es definitiva.',
    },
    sureCancelOrder: {
        en: 'Are you sure you want to cancel order creation? All information provided will be lost.',
        fr: 'Voulez-vous vraiment annuler la création de la commande ? Toutes les informations fournies seront perdues.',
        nl: 'Weet u zeker dat u het aanmaken van de bestelling wilt annuleren? Alle verstrekte informatie gaat verloren.',
        es: '¿Está seguro de que desea cancelar la creación del pedido? Toda la información proporcionada se perderá.',
    },
    sureRemoveDelivery: {
        en: 'Are you sure you want to delete delivery? All information provided will be lost.',
        fr: 'Voulez-vous vraiment supprimer la livraison ? Toutes les informations fournies seront perdues.',
        nl: 'Weet u zeker dat u de levering wilt verwijderen? Alle verstrekte informatie gaat verloren.',
        es: '¿Está seguro de que desea eliminar la entrega? Toda la información proporcionada se perderá.',
    },
    sureRemoveDeliveryTime: {
        en: 'Are you sure you want to delete delivery time? All information provided will be lost.',
        fr: 'Voulez-vous vraiment supprimer le délai de livraison ? Toutes les informations fournies seront perdues.',
        nl: 'Weet u zeker dat u de levertijd wilt verwijderen? Alle verstrekte informatie gaat verloren.',
        es: '¿Está seguro de que desea eliminar el tiempo de entrega? Toda la información proporcionada se perderá.',
    },
    sureRemoveAddress: {
        en: 'Are you sure you want to delete address? All information provided will be lost.',
        fr: "Voulez-vous vraiment supprimer l'adresse ? Toutes les informations fournies seront perdues.",
        nl: 'Weet u zeker dat u het adres wilt verwijderen? Alle verstrekte informatie gaat verloren.',
        es: '¿Está seguro de que desea eliminar la dirección? Toda la información proporcionada se perderá.',
    },
    sureRemoveDepartment: {
        en: 'Are you sure you want to delete the department? All information provided will be lost.',
        fr: 'Voulez-vous vraiment supprimer le département ? Toutes les informations fournies seront perdues.',
        nl: 'Weet u zeker dat u de afdeling wilt verwijderen? Alle verstrekte informatie gaat verloren.',
        es: '¿Está seguro de que desea eliminar el departamento? Toda la información proporcionada se perderá.',
    },
    sureRemoveOperatingCenter: {
        en: 'Are you sure you want to delete the operating center? All information provided will be lost.',
        fr: "Voulez-vous vraiment supprimer le centre d'exploitation ? Toutes les informations fournies seront perdues.",
        nl: 'Weet u zeker dat u het exploitatiecentrum wilt verwijderen? Alle verstrekte informatie gaat verloren.',
        es: '¿Está seguro de que desea eliminar el centro operativo? Toda la información proporcionada se perderá.',
    },
    publishedOn: {
        en: 'Published on',
        fr: 'Publié le',
        nl: 'Gepubliceerd op',
        es: 'Publicado el',
    },
    see: {
        en: 'See',
        fr: 'Voir',
        nl: 'Bekijken',
        es: 'Ver',
    },
    seeMore: {
        en: 'See more',
        fr: 'Voir plus',
        nl: 'Bekijk meer',
        es: 'Ver más',
    },
    seeLess: {
        en: 'See less',
        fr: 'Voir moins',
        nl: 'Bekijk minder',
        es: 'Ver menos',
    },
    remittance: {
        en: 'Entry',
        fr: 'Saisie',
        nl: 'Invoer',
        es: 'Entrada',
    },
    createdAt: {
        en: 'Created at',
        fr: 'Créé le',
        nl: 'Gemaakt op',
        es: 'Creado el',
    },
    helperBubbleInstruction: {
        fr: "Les instructions seront enregistrées pour les prochaines commandes (Ex : Les heures d'ouvertures de l'entrepôt sont 08h-12h & 13h-15h.)",
        en: 'The instructions will be recorded for the next orders (Ex: The opening hours of the warehouse are 08h-12h & 13h-15h.)',
        nl: 'De instructies worden opgeslagen voor de volgende bestellingen (Bijv: De openingstijden van het magazijn zijn 08u-12u & 13u-15u.)',
        es: 'Las instrucciones se guardarán para los próximos pedidos (Ej: El horario de apertura del almacén es 08h-12h y 13h-15h.)',
    },
    helperBubbleDeliveryRequirement: {
        fr: "Vous souhaitez informer l'exploitation d'une instruction très précise pour cette livraison (Ex : Appeler le client 30 min avant arrivée)",
        en: 'You want to inform the exploitation of a very precise instruction for this delivery (Ex: Call the client 30 min before arrival)',
        nl: 'U wilt de exploitatie informeren over een zeer specifieke instructie voor deze levering (Bijv: Bel de klant 30 min voor aankomst)',
        es: 'Desea informar a operaciones de una instrucción muy precisa para esta entrega (Ej: Llamar al cliente 30 min antes de la llegada)',
    },
    helperBubblePickupRequirement: {
        fr: "Vous souhaitez informer l'exploitation d'une instruction très précise pour cet enlèvement (Ex : Appeler l'entrepôt 30 min avant arrivée)",
        en: 'You want to inform the exploitation of a very precise instruction for this pickup (Ex: Call the warehouse 30 min before arrival)',
        nl: 'U wilt de exploitatie informeren over een zeer specifieke instructie voor deze afhaling (Bijv: Bel het magazijn 30 min voor aankomst)',
        es: 'Desea informar a operaciones de una instrucción muy precisa para esta recogida (Ej: Llamar al almacén 30 min antes de la llegada)',
    },
    loading: {
        en: 'Loading',
        fr: 'Chargement',
        nl: 'Laden',
        es: 'Cargando',
    },
    status: {
        en: 'Status',
        fr: 'Statut',
        nl: 'Status',
        es: 'Estado',
    },
    creationDate: {
        en: 'Creation date',
        fr: 'Date de création',
        nl: 'Aanmaakdatum',
        es: 'Fecha de creación',
    },
    orderWithId: {
        en: 'Order #{{orderId}}',
        fr: 'Commande n°{{orderId}}',
        nl: 'Bestelling #{{orderId}}',
        es: 'Pedido #{{orderId}}',
    },
    entryOrderNumber: {
        en: 'Entry/Order number',
        fr: 'Numéro de saisie',
        nl: 'Invoer/Bestelnummer',
        es: 'Número de entrada/pedido',
    },
    searchReferences: {
        fr: 'Références transport / DO',
        en: 'Transport / DO references',
        nl: 'Transport / DO-referenties',
        es: 'Referencias de transporte / DO',
    },
    homeArticleEntry: {
        en: 'Actuality entry',
        fr: 'Saisie actualité',
        nl: 'Nieuwsinvoer',
        es: 'Entrada de actualidad',
    },
    homeActualities: {
        en: 'Actualities',
        fr: 'Actualités',
        nl: 'Actualiteiten',
        es: 'Actualidades',
    },
    homeActualitys: {
        en: 'Articles',
        fr: 'Actualités',
        nl: 'Artikelen',
        es: 'Artículos',
    },
    homeArticle: {
        en: 'Actuality',
        fr: 'Actualité',
        nl: 'Actualiteit',
        es: 'Actualidad',
    },
    deleteHomeArticle: {
        en: 'Delete actuality',
        fr: "Supprimer l'actualité",
        nl: 'Actualiteit verwijderen',
        es: 'Eliminar actualidad',
    },
    sureDeleteHomeArticle: {
        en: 'Are you sure you want to delete the actuality? This action is final.',
        fr: "Êtes-vous certain de vouloir supprimer l'actualité ? Cette action est définitive.",
        nl: 'Weet u zeker dat u de actualiteit wilt verwijderen? Deze actie is definitief.',
        es: '¿Está seguro de que desea eliminar la actualidad? Esta acción es definitiva.',
    },
    startDate: {
        en: 'Start date',
        fr: 'Date début',
        nl: 'Startdatum',
        es: 'Fecha de inicio',
    },
    endDate: {
        en: 'End date',
        fr: 'Date fin',
        nl: 'Einddatum',
        es: 'Fecha de fin',
    },
    category: {
        en: 'Category',
        fr: 'Catégorie',
        nl: 'Categorie',
        es: 'Categoría',
    },
    homeActuality: {
        en: 'Article',
        fr: 'Actualité',
        nl: 'Artikel',
        es: 'Artículo',
    },
    homeArticles: {
        fr: 'Nouveautés',
        en: 'Novelties',
        nl: 'Nieuws',
        es: 'Novedades',
    },
    deleteHomeActuality: {
        en: 'Delete article',
        fr: "Supprimer l'actualité",
        nl: 'Artikel verwijderen',
        es: 'Eliminar artículo',
    },
    sureDeleteHomeActuality: {
        en: 'Are you sure you want to delete the article? This action is final.',
        fr: "Êtes-vous certain de vouloir supprimer l'article ? Cette action est définitive.",
        nl: 'Weet u zeker dat u het artikel wilt verwijderen? Deze actie is definitief.',
        es: '¿Está seguro de que desea eliminar el artículo? Esta acción es definitiva.',
    },
    url: {
        en: 'URL',
        fr: 'URL',
        nl: 'URL',
        es: 'URL',
    },
    urlDocument: {
        en: 'URL/Document',
        fr: 'URL/Document',
        nl: 'URL/Document',
        es: 'URL/Document',
    },
    lastTransportInGoing: {
        en: 'Last transport in progress',
        fr: 'Derniers transports en cours',
        nl: 'Laatste lopende transporten',
        es: 'Últimos transportes en curso',
    },
    lastViewedOrders: {
        en: 'Last viewed orders',
        fr: 'Dernières commandes consultées',
        nl: 'Laatst bekeken bestellingen',
        es: 'Últimos pedidos consultados',
    },
    news: {
        en: 'News',
        fr: 'Actualités',
        nl: 'Nieuws',
        es: 'Noticias',
    },
    return: {
        en: 'Return',
        fr: 'Retour',
        nl: 'Retour',
        es: 'Volver',
    },
    newOrder: {
        en: 'New order',
        fr: 'Nouvelle commande',
        nl: 'Nieuwe bestelling',
        es: 'Nuevo pedido',
    },
    transport: {
        en: 'Transport',
        fr: 'Transport',
        nl: 'Transport',
        es: 'Transporte',
    },
    deliverys: {
        en: 'Delivery(s)',
        fr: 'Livraison(s)',
        nl: 'Levering(en)',
        es: 'Entrega(s)',
    },
    confirmation: {
        en: 'Confirmation',
        fr: 'Confirmation',
        nl: 'Bevestiging',
        es: 'Confirmación',
    },
    confirmationBannerTextJetfreeze: {
        en: 'Your order must be placed before {{timeOrder}} (except weekends and holidays) if you want it to be picked up the next day.',
        fr: 'Votre commande doit être passée avant {{timeOrder}} (hors week-ends et jours fériés) si vous voulez qu’elle soit enlevée le jour suivant.',
        nl: 'Uw bestelling moet geplaatst zijn voor {{timeOrder}} (behalve in het weekend en op feestdagen) als u wilt dat deze de volgende dag wordt opgehaald.',
        es: 'Su pedido debe realizarse antes de las {{timeOrder}} (excepto fines de semana y festivos) si desea que se recoja al día siguiente.',
    },
    confirmationBannerTextPineau: {
        en: 'Your order must be placed before {{timeOrder}}, the {{dayOfTheWeek}} of the week S-1 of the delivery.',
        fr: 'Votre commande doit être passée avant {{timeOrder}}, le {{dayOfTheWeek}} de la semaine S-1 de la livraison.',
        nl: 'Uw bestelling moet geplaatst zijn voor {{timeOrder}} op {{dayOfTheWeek}} van week S-1 van de levering.',
        es: 'Su pedido debe realizarse antes de las {{timeOrder}}, el {{dayOfTheWeek}} de la semana S-1 de la entrega.',
    },
    specifications: {
        en: 'Specifications',
        fr: 'Spécifications',
        nl: 'Specificaties',
        es: 'Especificaciones',
    },
    orderDay: {
        en: 'Order day',
        fr: 'Jour de commande',
        nl: 'Besteldag',
        es: 'Día de pedido',
    },
    next: {
        en: 'Next',
        fr: 'Suivant',
        nl: 'Volgende',
        es: 'Siguiente',
    },
    previous: {
        en: 'Previous',
        fr: 'Précédent',
        nl: 'Vorige',
        es: 'Anterior',
    },
    cancelEntry: {
        en: 'Cancel entry',
        fr: 'Annuler la saisie',
        nl: 'Invoer annuleren',
        es: 'Cancelar entrada',
    },
    pickup: {
        en: 'Pickup',
        fr: 'Enlèvement',
        nl: 'Afhaling',
        es: 'Recogida',
    },
    complement: {
        en: 'Complement',
        fr: 'Complément',
        nl: 'Aanvulling',
        es: 'Complemento',
    },
    summary: {
        en: 'Summary',
        fr: 'Récapitulatif',
        nl: 'Overzicht',
        es: 'Resumen',
    },
    enterNewService: {
        fr: 'Saisir une nouvelle prestation',
        en: 'Enter a new service',
        nl: 'Nieuwe dienst invoeren',
        es: 'Introducir un nuevo servicio',
    },
    label: {
        fr: 'Libellé',
        en: 'Label',
        nl: 'Label',
        es: 'Etiqueta',
    },
    updateService: {
        fr: 'Mettre à jour la prestation',
        en: 'Update service',
        nl: 'Dienst bijwerken',
        es: 'Actualizar servicio',
    },
    quotationSummary: {
        fr: 'Chiffrage du devis',
        en: 'Quotation summary',
        nl: 'Offerte-overzicht',
        es: 'Resumen de cotización',
    },
    serviceLabel: {
        fr: 'Libellé de la prestation',
        en: 'Service label',
        nl: 'Dienstlabel',
        es: 'Etiqueta de servicio',
    },
    totalPrice: {
        fr: 'Prix TTC estimé',
        en: 'Estimated price incl. tax',
        nl: 'Geschatte totaalprijs incl. btw',
        es: 'Precio estimado con IVA',
    },
    totalPriceEstimated: {
        fr: 'Prix total TTC estimé',
        en: 'Estimated total price incl. VAT',
        nl: 'Geschatte totaalprijs incl. btw',
        es: 'Precio total estimado con IVA',
    },
    unitPrice: {
        en: 'Unit price',
        fr: 'Prix unitaire',
        nl: 'Eenheidsprijs',
        es: 'Precio unitario',
    },
    priceExclTax: {
        fr: 'Coût HT',
        en: 'Price excl. tax',
        nl: 'Prijs excl. btw',
        es: 'Precio sin IVA',
    },
    vat: {
        en: 'Estimated VAT',
        fr: 'TVA estimée',
        nl: 'Geschatte btw',
        es: 'IVA estimado',
    },
    addService: {
        en: 'Add service',
        fr: 'Ajouter une prestation',
        nl: 'Dienst toevoegen',
        es: 'Añadir servicio',
    },
    deleteService: {
        en: 'Delete service',
        fr: 'Supprimer la prestation',
        nl: 'Dienst verwijderen',
        es: 'Eliminar servicio',
    },
    serviceHasBeenRemoved: {
        en: 'The service has been removed',
        fr: 'La prestation a été supprimée',
        nl: 'De dienst is verwijderd',
        es: 'El servicio ha sido eliminado',
    },
    validationOfTheCommercialProposal: {
        fr: 'Validation de la proposition commerciale',
        en: 'Validation of the commercial proposal',
        nl: 'Validatie van het commerciële voorstel',
        es: 'Validación de la propuesta comercial',
    },
    commercialProposalPrices: {
        en: 'Commercial proposal: {{price}} excl. tax ({{totalPrice}} incl. tax)',
        fr: 'Proposition commerciale : {{price}} HT ({{totalPrice}} TTC)',
        nl: 'Commercieel voorstel: {{price}} excl. btw ({{totalPrice}} incl. btw)',
        es: 'Propuesta comercial: {{price}} sin IVA ({{totalPrice}} con IVA)',
    },
    listOfServiceLines: {
        fr: 'Liste des lignes de prestations :',
        en: 'List of service lines:',
        nl: 'Lijst van diensten:',
        es: 'Lista de líneas de servicio:',
    },
    numberOfServiceLines: {
        fr: 'Nombre de lignes de prestations : {{nb}}',
        en: 'Number of service lines: {{nb}}',
        nl: 'Aantal diensten: {{nb}}',
        es: 'Número de líneas de servicio: {{nb}}',
    },
    saveTemporarily: {
        en: 'Save temporarily',
        fr: 'Enregistrer temporairement',
        nl: 'Tijdelijk opslaan',
        es: 'Guardar temporalmente',
    },
    research: {
        en: 'Research',
        fr: 'Rechercher',
        nl: 'Zoeken',
        es: 'Investigación',
    },
    resetFilters: {
        en: 'Click to reset filters',
        fr: 'Cliquez pour réinitialiser les filtres',
        nl: 'Klik om filters te resetten',
        es: 'Haga clic para restablecer filtros',
    },
    addAddress: {
        en: 'Add address',
        fr: 'Ajouter une adresse',
        nl: 'Adres toevoegen',
        es: 'Añadir dirección',
    },
    addArticle: {
        en: 'Add article',
        fr: 'Ajouter une marchandise',
        nl: 'Artikel toevoegen',
        es: 'Añadir artículo',
    },
    addParcel: {
        en: 'Add parcel',
        fr: 'Ajouter colis',
        nl: 'Pakket toevoegen',
        es: 'Añadir paquete',
    },
    parcel: {
        en: 'Parcel',
        fr: 'Colis',
        nl: 'Pakket',
        es: 'Paquete',
    },
    pickupInstruction: {
        en: 'Pickup instruction',
        fr: "Instruction d'enlèvement",
        nl: 'Afhaalinstructie',
        es: 'Instrucción de recogida',
    },
    pickupRequirement: {
        en: 'Pickup requirement',
        fr: "Impératif d'enlèvement",
        nl: 'Afhaalvereiste',
        es: 'Requisito de recogida',
    },
    writeAnImperative: {
        en: 'Write a requirement',
        fr: 'Écrire un impératif',
        nl: 'Schrijf een vereiste',
        es: 'Escribir un requisito',
    },
    pickupStartWindow: {
        en: 'Desired pickup start time',
        fr: "Heure de début d'enlèv. souhaitée",
        nl: 'Gewenste starttijd afhaling',
        es: 'Hora de inicio de recogida deseada',
    },
    pickupEndWindow: {
        en: 'Desired pickup end time',
        fr: "Heure de fin d'enlèv. souhaitée",
        nl: 'Gewenste eindtijd afhaling',
        es: 'Hora de fin de recogida deseada',
    },
    logisticConstraints: {
        en: 'Logistic constraints',
        fr: 'Contraintes logistiques',
        nl: 'Logistieke beperkingen',
        es: 'Restricciones logísticas',
    },
    select: {
        en: 'Select',
        fr: 'Sélectionner',
        nl: 'Selecteren',
        es: 'Seleccionar',
    },
    selectAll: {
        en: 'Select all',
        fr: 'Tout sélectionner',
        nl: 'Alles selecteren',
        es: 'Seleccionar todo',
    },
    nbSelected: {
        en: '{{nb}} selected',
        fr: '{{nb}} sélectionné(s)',
        nl: '{{nb}} geselecteerd',
        es: '{{nb}} seleccionado(s)',
    },
    selectAllWithNb: {
        en: 'Select all ({{nb}})',
        fr: 'Tout sélectionner ({{nb}})',
        nl: 'Alles selecteren ({{nb}})',
        es: 'Seleccionar todo ({{nb}})',
    },
    deselect: {
        en: 'Deselect ({{nb}})',
        fr: 'Désélectionner ({{nb}})',
        nl: 'Deselecteren ({{nb}})',
        es: 'Deseleccionar ({{nb}})',
    },
    deliveryInstructions: {
        en: 'Delivery instructions',
        fr: 'Instructions de livraison',
        nl: 'Leveringsinstructies',
        es: 'Instrucciones de entrega',
    },
    deliveryRequirement: {
        en: 'Delivery requirement',
        fr: 'Impératif de livraison',
        nl: 'Leveringsvereiste',
        es: 'Requisito de entrega',
    },
    contact: {
        en: 'Contact',
        fr: 'Contact',
        nl: 'Contact',
        es: 'Contacto',
    },
    contactType: {
        en: 'Contact role',
        fr: 'Rôle du contact',
        nl: 'Contactrol',
        es: 'Rol del contacto',
    },
    orderingPartyReference: {
        en: 'Ordering party reference',
        fr: "Référence donneur d'ordre",
        nl: 'Opdrachtgever-referentie',
        es: 'Referencia del contratante',
    },
    orderingPartyReferenceTooltip: {
        fr: 'Saisir votre référence pour cette commande de transport. Cette référence doit être unique et différente des autres commandes. (100 caractères max)',
        en: 'Enter your reference for this transport order. This reference must be unique and different from other orders. (100 characters max)',
        nl: 'Voer uw referentie in voor deze transportopdracht. Deze referentie moet uniek zijn. (max. 100 tekens)',
        es: 'Introduzca su referencia para este pedido de transporte. Esta referencia debe ser única y diferente de otros pedidos. (Máx. 100 caracteres)',
    },
    referenceNumber: {
        en: 'Reference number',
        fr: 'Numéro de référence',
        nl: 'Referentienummer',
        es: 'Número de referencia',
    },
    merchandiseComment: {
        en: 'Handling comment',
        fr: 'Commentaire manutention',
        nl: 'Behandelingsopmerking',
        es: 'Comentario de manipulación',
    },
    handlingCommentTooltip: {
        en: 'This comment allows you to inform our logistics teams on the handling of goods.',
        fr: "Ce commentaire permet d'informer nos équipes logistiques sur la manutention des marchandises.",
        nl: 'Deze opmerking dient om onze logistieke teams te informeren over de behandeling van de goederen.',
        es: 'Este comentario permite informar a nuestros equipos logísticos sobre la manipulación de las mercancías.',
    },
    writeAComment: {
        en: 'Write a comment',
        fr: 'Écrire un commentaire',
        nl: 'Schrijf een opmerking',
        es: 'Escribir un comentario',
    },
    invoiceComment: {
        fr: 'Commentaire CMR',
        en: 'CMR comment',
        nl: 'CMR-opmerking',
        es: 'Comentario CMR',
    },
    invoiceCommentTooltip: {
        fr: 'Ce commentaire sera affiché sur la CMR.',
        en: 'This comment will be displayed on the CMR.',
        nl: 'Deze opmerking wordt weergegeven op de CMR.',
        es: 'Este comentario se mostrará en el CMR.',
    },
    typeOfDelivery: {
        en: 'Type of delivery',
        fr: 'Type de livraison',
        nl: 'Type levering',
        es: 'Tipo de entrega',
    },
    telephoneAppointment: {
        en: 'Appointment making',
        fr: 'Prise de RDV',
        nl: 'Afspraak maken',
        es: 'Programación de citas',
    },
    otNumber: {
        en: 'OT number',
        fr: 'Numéro OT',
        nl: 'OT-nummer',
        es: 'Número OT',
    },
    commentAppointment: {
        en: 'Appointment comment',
        fr: 'Commentaire rendez-vous',
        nl: 'Opmerking afspraak',
        es: 'Comentario de cita',
    },
    appointmentReference: {
        en: 'Appointment reference',
        fr: 'Référence rendez-vous',
        nl: 'Afspraakreferentie',
        es: 'Referencia de cita',
    },
    amount: {
        en: 'Amount',
        fr: 'Montant',
        nl: 'Bedrag',
        es: 'Cantidad',
    },
    againstReimbursement: {
        en: 'Cash on delivery',
        fr: 'Contre-remboursement',
        nl: 'Rembours',
        es: 'Contra reembolso',
    },
    desiredWeek: {
        en: 'Desired week',
        fr: 'Semaine souhaitée',
        nl: 'Gewenste week',
        es: 'Semana deseada',
    },
    chooseWeek: {
        en: 'Choose week',
        fr: 'Choisir semaine',
        nl: 'Kies week',
        es: 'Elegir semana',
    },
    chooseDate: {
        en: 'Choose a date',
        fr: 'Choisir une date',
        nl: 'Kies een datum',
        es: 'Elegir una fecha',
    },
    wishedDateOfDelivery: {
        en: 'Desired delivery date',
        fr: 'Date de livraison impérative souhaitée',
        nl: 'Gewenste leveringsdatum',
        es: 'Fecha de entrega deseada',
    },
    addHandlingUnit: {
        en: 'Add Handling Unit',
        fr: 'Ajouter Unité de Manutention',
        nl: 'Logistieke eenheid toevoegen',
        es: 'Añadir unidad de manipulación',
    },
    handlingUnit: {
        en: 'Handling Unit',
        fr: 'Unité de manutention',
        nl: 'Logistieke eenheid',
        es: 'Unidad de manipulación',
    },
    HU: {
        en: 'HU(s)',
        fr: 'UM(s)',
        nl: 'HU(s)',
        es: 'HU(s)',
    },
    support: {
        en: 'Support',
        fr: 'Support',
        nl: 'Drager',
        es: 'Soporte',
    },
    supports: {
        en: 'Supports',
        fr: 'Supports',
        nl: 'Dragers',
        es: 'Soportes',
    },
    emptySubHandlingError: {
        en: 'At least 1 article is required',
        fr: 'Au moins 1 article est requis',
        nl: 'Minimaal 1 artikel is vereist',
        es: 'Se requiere al menos 1 artículo',
    },
    emptyMerchandiseError: {
        en: 'At least 1 merchandise is required',
        fr: 'Au moins 1 marchandise est requise',
        nl: 'Minimaal 1 goed is vereist',
        es: 'Se requiere al menos 1 mercancía',
    },
    ref: {
        en: 'Ref',
        fr: 'Réf',
        nl: 'Ref',
        es: 'Ref',
    },
    weight: {
        en: 'Weight',
        fr: 'Poids',
        nl: 'Gewicht',
        es: 'Peso',
    },
    totalWeight: {
        en: 'Total weight',
        fr: 'Poids total',
        nl: 'Totaal gewicht',
        es: 'Peso total',
    },
    calculatedFootage: {
        en: 'Unit linear footage calculated with your dimensions',
        fr: 'Métrage linéaire unitaire calculé avec vos dimensions',
        nl: 'Lineaire meterage berekend met uw afmetingen',
        es: 'Metraje lineal unitario calculado con sus dimensiones',
    },
    footageCannotBeDetermined: {
        en: 'Enter the length and width to calculate the linear footage.',
        fr: 'Renseignez la longueur et la largeur pour calculer le métrage linéaire.',
        nl: 'Vul de lengte en breedte in om het lineaire metrage te berekenen.',
        es: 'Indique la longitud y la anchura para calcular el metraje lineal.',
    },
    articleDefaultFootageMissing: {
        en: 'No default linear footage is configured for this merchandise.',
        fr: 'Aucun métrage linéaire par défaut n’est configuré pour cette marchandise.',
        nl: 'Er is geen standaard lineair metrage geconfigureerd voor dit artikel.',
        es: 'No hay ningún metraje lineal predeterminado configurado para esta mercancía.',
    },
    unitLinearFootage: {
        en: 'Unit linear footage',
        fr: 'Métrage linéaire unitaire',
        nl: 'Lineaire meterage per eenheid',
        es: 'Metraje lineal unitario',
    },
    footage: {
        en: 'Footage',
        fr: 'Métrage',
        nl: 'Meterage',
        es: 'Metraje',
    },
    linearMeterSuffix: {
        en: 'LM',
        fr: 'ML',
        nl: 'LM',
        es: 'ML',
    },
    long: {
        en: 'Length',
        fr: 'Longueur',
        nl: 'Lengte',
        es: 'Longitud',
    },
    width: {
        en: 'Width',
        fr: 'Largeur',
        nl: 'Breedte',
        es: 'Anchura',
    },
    height: {
        en: 'Height',
        fr: 'Hauteur',
        nl: 'Hoogte',
        es: 'Altura',
    },
    addAFile: {
        en: 'Add a file',
        fr: 'Ajouter un fichier',
        nl: 'Bestand toevoegen',
        es: 'Añadir un archivo',
    },
    careForDimensions: {
        fr: "Marchandises hors normes (>5 mètres), assurez-vous d'avoir renseigné les bonnes dimensions. Nos dimensions max sont : Long 7 mètres max. Larg 2,45 mètres max. Haut 2,4 mètres max.",
        en: 'Non-standard goods (>5 meters), make sure you have entered the correct dimensions. Our maximum dimensions are: Length 7 meters max. Width 2.45 meters max. Height 2.4 meters max.',
        nl: 'Buitenmaatse goederen (>5 meter), zorg voor de juiste afmetingen. Onze max. maten zijn: L 7m, B 2,45m, H 2,4m.',
        es: 'Mercancías fuera de norma (>5 metros), asegúrese de haber introducido las dimensiones correctas. Nuestras dimensiones máx. son: Largo 7m máx., Ancho 2,45m máx., Alto 2,4m máx.',
    },
    hasMissingFile: {
        en: 'Missing files',
        fr: 'Fichiers manquants',
        nl: 'Ontbrekende bestanden',
        es: 'Archivos faltantes',
    },
    missingDate: {
        en: 'The date is missing, please fill it in.',
        fr: 'La date est manquante, merci de la renseigner.',
        nl: 'De datum ontbreekt, vul deze in.',
        es: 'Falta la fecha, por favor complétela.',
    },
    clickOrDragYourFileHere: {
        en: 'Click or drag your file here.',
        fr: 'Cliquez ou glissez votre fichier ici.',
        nl: 'Klik of sleep uw bestand hierheen.',
        es: 'Haga clic o arrastre su archivo aquí.',
    },
    total: {
        en: 'Price excl. VAT',
        fr: 'Prix HT',
        nl: 'Prijs excl. btw',
        es: 'Precio sin IVA',
    },
    totalHtEstimated: {
        en: 'Total price excl. VAT',
        fr: 'Prix total HT',
        nl: 'Totale prijs excl. btw',
        es: 'Precio total sin IVA',
    },
    destinations: {
        en: 'Destination(s)',
        fr: 'Destination(s)',
        nl: 'Bestemming(en)',
        es: 'Destino(s)',
    },
    article: {
        en: 'Article',
        fr: 'Marchandise',
        nl: 'Artikel',
        es: 'Artículo',
    },
    articles: {
        en: 'Article(s)',
        fr: 'Marchandise(s)',
        nl: 'Artikelen',
        es: 'Artículo(s)',
    },
    editSummary: {
        en: 'Edit Summary',
        fr: 'Éditer Récapitulatif',
        nl: 'Overzicht bewerken',
        es: 'Editar resumen',
    },
    trackingLink: {
        en: 'Tracking link',
        fr: 'Lien de suivi',
        nl: 'Trackinglink',
        es: 'Enlace de seguimiento',
    },
    labels: {
        en: 'Labels',
        fr: 'Étiquettes',
        nl: 'Etiketten',
        es: 'Etiquetas',
    },
    send: {
        en: 'Send',
        fr: 'Envoyer',
        nl: 'Verzenden',
        es: 'Enviar',
    },
    sendTrackingLink: {
        en: 'Send tracking link by email',
        fr: 'Envoi du lien de suivi par email',
        nl: 'Trackinglink per e-mail verzenden',
        es: 'Enviar enlace de seguimiento por correo',
    },
    index: {
        en: 'Index',
        fr: 'Index',
        nl: 'Index',
        es: 'Índice',
    },
    merchandises: {
        en: 'Merchandise(s)',
        fr: 'Marchandise(s)',
        nl: 'Goederen',
        es: 'Mercancía(s)',
    },
    addNewDelivery: {
        en: 'Add new delivery',
        fr: 'Ajouter nouvelle livraison',
        nl: 'Nieuwe levering toevoegen',
        es: 'Añadir nueva entrega',
    },
    weekNb: {
        en: 'Week {{i}}',
        fr: 'Semaine {{i}}',
        nl: 'Week {{i}}',
        es: 'Semana {{i}}',
    },
    week: {
        en: 'Week',
        fr: 'Semaine',
        nl: 'Week',
        es: 'Semana',
    },
    reference: {
        en: 'Reference',
        fr: 'Référence',
        nl: 'Referentie',
        es: 'Referencia',
    },
    addUrl: {
        en: 'Add URL',
        fr: 'Ajouter une URL',
        nl: 'URL toevoegen',
        es: 'Añadir URL',
    },
    warninFileSettings: {
        en: 'Be careful, by adding files here, you completely overwrite the parameters of the company files.',
        fr: 'Attention, en ajoutant des fichiers ici, vous écrasez entièrement les paramètres des fichiers de la société.',
        nl: 'Let op: door hier bestanden toe te voegen, overschrijft u de instellingen van het bedrijf.',
        es: 'Cuidado, al añadir archivos aquí, sobrescribe completamente los parámetros de la empresa.',
    },
    writeReference: {
        en: 'Write reference',
        fr: 'Écrire référence',
        nl: 'Referentie schrijven',
        es: 'Escribir referencia',
    },
    transportTracking: {
        en: 'Transport tracking',
        fr: 'Suivi transport',
        nl: 'Transport volgen',
        es: 'Seguimiento de transporte',
    },
    supported: {
        en: 'Supported',
        fr: 'Prise en charge',
        nl: 'Ondersteund',
        es: 'Soportado',
    },
    forwarding: {
        en: 'Forwarding',
        fr: 'Acheminement',
        nl: 'Doorsturen',
        es: 'Reenvío',
    },
    preparationForDelivery: {
        en: 'Preparation for delivery',
        fr: 'Mise en livraison',
        nl: 'Voorbereiding levering',
        es: 'Preparación para entrega',
    },
    delivered: {
        en: 'Delivered',
        fr: 'Livré',
        nl: 'Geleverd',
        es: 'Entregado',
    },
    carrier: {
        en: 'Carrier',
        fr: 'Transporteur',
        nl: 'Vervoerder',
        es: 'Transportista',
    },
    case: {
        en: 'Case',
        fr: 'Dossier',
        nl: 'Dossier',
        es: 'Expediente',
    },
    agency: {
        en: 'Agency',
        fr: 'Agence',
        nl: 'Agentschap',
        es: 'Agencia',
    },
    remittanceEntry: {
        en: 'Remittance entry',
        fr: 'Saisie remise',
        nl: 'Kortingsinvoer',
        es: 'Entrada de remesa',
    },
    gedmouv: {
        en: 'Gedmouv',
        fr: 'Gedmouv',
        nl: 'Gedmouv',
        es: 'Gedmouv',
    },
    trackingFooter: {
        en: `{{name}}, a subsidiary of the MOUSSET Group © Copyright ${new Date().getFullYear()} - All rights reserved - Legal notice`,
        fr: `{{name}}, une filiale du Groupe MOUSSET © Copyright ${new Date().getFullYear()} - Tous droits réservés - Mentions légales`,
        nl: `{{name}}, een dochteronderneming van de MOUSSET Group © Copyright ${new Date().getFullYear()} - Alle rechten voorbehouden - Juridische kennisgeving`,
        es: `{{name}}, una filial del Grupo MOUSSET © Copyright ${new Date().getFullYear()} - Todos los derechos reservados - Aviso legal`,
    },
    plannedFor: {
        en: 'Planned for',
        fr: 'Estimé le',
        nl: 'Gepland voor',
        es: 'Planificado para',
    },
    removedOn: {
        en: 'Removed on',
        fr: 'Enlevé le',
        nl: 'Afgehaald op',
        es: 'Retirado el',
    },
    deliveredOn: {
        en: 'Delivered on',
        fr: 'Livré le',
        nl: 'Geleverd op',
        es: 'Entregado el',
    },
    plannedThe: {
        fr: 'Planifié le',
        en: 'Planned the',
        nl: 'Gepland op',
        es: 'Planificado el',
    },
    billing: {
        en: 'Billing',
        fr: 'Facturation',
        nl: 'Facturering',
        es: 'Facturación',
    },
    anomalies: {
        en: 'Anomalies',
        fr: 'Anomalies',
        nl: 'Afwijkingen',
        es: 'Anomalías',
    },
    price: {
        en: 'Price',
        fr: 'Prix',
        nl: 'Prijs',
        es: 'Precio',
    },
    billNumber: {
        en: 'Bill number',
        fr: 'Numéro de facture',
        nl: 'Factuurnummer',
        es: 'Número de factura',
    },
    authorizedDdeliveryTypes: {
        en: 'Types of delivery allowed',
        fr: 'Types de livraison autorisés',
        nl: 'Toegestane leveringstypes',
        es: 'Tipos de entrega permitidos',
    },
    supplier: {
        en: 'Supplier',
        fr: 'Fournisseur',
        nl: 'Leverancier',
        es: 'Proveedor',
    },
    comfourNumber: {
        en: 'COMFOUR supplier number',
        fr: 'Numéro de fournisseur COMFOUR',
        nl: 'COMFOUR-leveranciersnummer',
        es: 'Número de proveedor COMFOUR',
    },
    allegroNumber: {
        en: 'Order number to suppliers (ALLEGRO/EDI)',
        fr: 'Numéro de commande aux fournisseurs (ALLEGRO/EDI)',
        nl: 'Bestelnummer aan leveranciers (ALLEGRO/EDI)',
        es: 'Número de pedido a proveedores (ALLEGRO/EDI)',
    },
    allegroNumberShort: {
        en: 'Allegro/EDI number',
        fr: 'Numéro Allegro/EDI',
        nl: 'Allegro/EDI-nummer',
        es: 'Número Allegro/EDI',
    },
    location: {
        en: 'Location',
        fr: 'Localisation',
        nl: 'Locatie',
        es: 'Ubicación',
    },
    informationFillInAddressInformation: {
        en: 'Information (Fill in address information)',
        fr: "Informations (Renseigner les informations sur l'adresse)",
        nl: 'Informatie (Adresgegevens invullen)',
        es: 'Información (Completar información de dirección)',
    },
    toEnsureThatOurDriverArrivesEasily: {
        en: 'To ensure that our driver arrives easily at the site thanks to an accurate GPS route, we advise you to check the GPS coordinates of the address.\r\nThis information also allows us to detect arrivals and departures from the site.',
        fr: "Pour vous assurer que notre conducteur arrive facilement sur le site grâce à un itinéraire GPS précis, nous vous conseillons de vérifier les coordonnées GPS de l'adresse.\r\nCette information permet aussi de détecter les arrivées et départs du site.",
        nl: 'Om een vlotte aankomst van onze chauffeur te garanderen, adviseren wij u de GPS-coördinaten te controleren.',
        es: 'Para asegurar que nuestro conductor llegue fácilmente al sitio, le aconsejamos verificar las coordenadas GPS.',
    },
    ifYourAddressIsNotListed: {
        en: 'If your address is not listed, you can place the cursor manually to get the GPS coordinates and save them.',
        fr: "Si votre adresse n'est pas répertoriée, vous pouvez placer le curseur manuellement pour obtenir les coordonnées GPS et les enregistrer.",
        nl: 'Als uw adres niet in de lijst staat, kunt u de cursor handmatig plaatsen.',
        es: 'Si su dirección no figura en la lista, puede colocar el cursor manualmente.',
    },
    placeCursorManually: {
        en: 'Place cursor manually',
        fr: 'Placer le curseur manuellement',
        nl: 'Cursor handmatig plaatsen',
        es: 'Colocar cursor manualmente',
    },
    moveTheCursor: {
        en: 'Move the cursor on the map to define the address you want.',
        fr: "Déplacer le curseur sur la carte pour définir l'adresse que vous souhaitez.",
        nl: 'Verplaats de cursor op de kaart naar het gewenste adres.',
        es: 'Mueva el cursor en el mapa para definir la dirección deseada.',
    },
    latitude: {
        en: 'Latitude',
        fr: 'Latitude',
        nl: 'Breedtegraad',
        es: 'Latitud',
    },
    longitude: {
        en: 'Longitude',
        fr: 'Longitude',
        nl: 'Lengtegraad',
        es: 'Longitud',
    },
    invoiceEntry: {
        en: 'Invoices',
        fr: 'Factures',
        nl: 'Facturen',
        es: 'Facturas',
    },
    allTheInvoices: {
        en: 'All the invoices',
        fr: 'Toutes les factures',
        nl: 'Alle facturen',
        es: 'Todas las facturas',
    },
    invoices: {
        en: 'Invoices',
        fr: 'Factures',
        nl: 'Facturen',
        es: 'Facturas',
    },
    invoiceNumber: {
        en: 'Invoice number',
        fr: 'Numéro facture',
        nl: 'Factuurnummer',
        es: 'Número de factura',
    },
    number: {
        en: 'number',
        fr: 'Numéro',
        nl: 'Nummer',
        es: 'Número',
    },
    InvoiceLabel: {
        en: 'Invoice label',
        fr: 'Libellé facture',
        nl: 'Factuurlabel',
        es: 'Etiqueta de factura',
    },
    wording: {
        en: 'Wording',
        fr: 'Libellé',
        nl: 'Omschrijving',
        es: 'Descripción',
    },
    amountExcludingVat: {
        en: 'Amount excluding VAT',
        fr: 'Montant HT',
        nl: 'Bedrag excl. btw',
        es: 'Importe sin IVA',
    },
    deadlineDate: {
        en: 'Deadline date',
        fr: "Date d'échéance",
        nl: 'Vervaldatum',
        es: 'Fecha límite',
    },
    amountIncludingVat: {
        en: 'Amount including VAT',
        fr: 'Montant TTC',
        nl: 'Bedrag incl. btw',
        es: 'Importe con IVA',
    },
    deleteInvoice: {
        en: 'Delete invoice',
        fr: 'Supprimer la facture',
        nl: 'Factuur verwijderen',
        es: 'Eliminar factura',
    },
    sureDeleteInvoice: {
        en: 'Are you sure you want to delete the invoice ? This action is definitive.',
        fr: 'Êtes-vous certains de vouloir supprimer la facture ? Cette action est définitive.',
        nl: 'Weet u zeker dat u de factuur wilt verwijderen? Deze actie is definitief.',
        es: '¿Está seguro de que desea eliminar la factura? Esta acción es definitiva.',
    },
    transportNumber: {
        en: 'Transport number',
        fr: 'Numéro du transport',
        nl: 'Transportnummer',
        es: 'Número de transporte',
    },
    file: {
        en: 'File',
        fr: 'Fichier',
        nl: 'Bestand',
        es: 'Archivo',
    },
    urlFile: {
        en: 'URL file',
        fr: 'Fichier URL',
        nl: 'URL-bestand',
        es: 'Archivo URL',
    },
    documentEntry: {
        en: 'Documents',
        fr: 'Documents',
        nl: 'Documenten',
        es: 'Documentos',
    },
    allTheDocuments: {
        en: 'All the documents',
        fr: 'Tous les documents',
        nl: 'Alle documenten',
        es: 'Todos los documentos',
    },
    unit: {
        en: 'Unit',
        fr: 'Unité',
        nl: 'Eenheid',
        es: 'Unidad',
    },
    tariffCode: {
        en: 'Tariff code',
        fr: 'Code tarif',
        nl: 'Tariefcode',
        es: 'Código de tarifa',
    },
    tariffType: {
        en: 'Type of tariff',
        fr: 'Type de tarif',
        nl: 'Tarieftype',
        es: 'Tipo de tarifa',
    },
    excelFile: {
        en: 'Excel file',
        fr: 'Fichier Excel',
        nl: 'Excel-bestand',
        es: 'Archivo Excel',
    },
    prices: {
        en: 'Prices',
        fr: 'Tarifs',
        nl: 'Prijzen',
        es: 'Precios',
    },
    unitTaxed: {
        en: 'Unit taxed',
        fr: 'Unité taxée',
        nl: 'Belaste eenheid',
        es: 'Unidad gravada',
    },
    version: {
        en: 'Version',
        fr: 'Version',
        nl: 'Versie',
        es: 'Versión',
    },
    newEntry: {
        en: 'New entry',
        fr: 'Nouvelle commande',
        nl: 'Nieuwe invoer',
        es: 'Nueva entrada',
    },
    pickupWindowTooltip: {
        en: 'The slots are intended to give you a more precise idea of the time you want to be picked up. Given that they can be affected by external factors such as traffic, planning they are not guaranteed and can be changed.',
        fr: "Les créneaux ont pour but de vous donner une idée plus précise du moment où vous souhaitez être enlevé. Étant donné qu'ils peuvent être affectés par des facteurs externes tels que la circulation ou la planification, ils ne sont pas garantis et peuvent être modifiés.",
        nl: 'De tijdslots zijn een indicatie. Door verkeer of planning kunnen deze worden gewijzigd.',
        es: 'Las franjas son para dar una idea del momento de recogida. Debido al tráfico o planificación, no están garantizadas.',
    },
    deliveryComplements: {
        en: 'Delivery complements',
        fr: 'Compléments livraison',
        nl: 'Leveringsaanvullingen',
        es: 'Complementos de entrega',
    },
    wishedDateOfDeliveryTooltip: {
        en: 'The delivery date is intended to give you a more precise idea of the time you want to be delivered. Given that it can be affected by external factors such as planning, traffic, it cannot be guaranteed and can be changed by the carrier.',
        fr: "La date de livraison a pour but de donner une idée plus précise du moment où vous souhaitez être livré. Étant donné qu'elle peut être affectée par des facteurs externes tels que la planification ou la circulation, elle ne peut être garantie et peut être modifiée par le transporteur.",
        nl: 'De leverdatum is een indicatie. De vervoerder kan deze wijzigen door externe factoren.',
        es: 'La fecha de entrega es una indicación. El transportista puede modificarla por factores externos.',
    },

    desiredWeekTooltip: {
        en: 'For orders entered after Tuesday afternoon of the current week, delivery during the following week cannot be guaranteed by Transports PINEAU.',
        fr: 'Si la commande est saisie après le mardi après-midi de la semaine S, Transports PINEAU ne pourra garantir la livraison la semaine suivante.',
        nl: 'Voor bestellingen die na dinsdagmiddag van de lopende week worden ingevoerd, kan Transports PINEAU levering in de daaropvolgende week niet garanderen.',
        es: 'Para los pedidos registrados después del martes por la tarde de la semana en curso, Transports PINEAU no puede garantizar la entrega durante la semana siguiente.',
    },
    content2: {
        en: 'Content',
        fr: 'Contenu',
        nl: 'Inhoud',
        es: 'Contenido',
    },
    legalMentions: {
        en: 'Legal notice',
        fr: 'Mentions légales',
        nl: 'Juridische kennisgeving',
        es: 'Aviso legal',
    },
    clickingValidate: {
        en: 'By clicking on "Validate", you accept the conditions of use of the site described in the Legal notice.',
        fr: 'En cliquant sur "Valider", vous acceptez les conditions d\'utilisation du site décrites dans les Mentions légales.',
        nl: 'Door op "Valideren" te klikken, accepteert u de gebruiksvoorwaarden.',
        es: 'Al hacer clic en "Validar", acepta las condiciones de uso descritas en el Aviso legal.',
    },
    share: {
        en: 'Share',
        fr: 'Partager',
        nl: 'Delen',
        es: 'Compartir',
    },
    shareTrackingLinkSubtitle: {
        en: 'Enter the emails to send the follow-up sharing link to.',
        fr: 'Saisissez les e-mails auxquels envoyer le lien de partage du suivi.',
        nl: 'Voer de e-mails in waarnaar de trackinglink moet worden verzonden.',
        es: 'Introduzca los correos para enviar el enlace de seguimiento.',
    },
    estimateDeliveryDateDescription: {
        en: 'Estimate the delivery date of your transport from a loading place and a destination place.',
        fr: "Estimez la date de livraison de votre transport à partir d'un lieu de chargement et d'un lieu de destination.",
        nl: 'Bereken de leverdatum vanaf de laadplaats naar de bestemming.',
        es: 'Estime la fecha de entrega desde el lugar de carga hasta el destino.',
    },
    estimateDeliveryDate: {
        en: 'Estimate delivery date',
        fr: 'Estimer la date de livraison',
        nl: 'Leverdatum berekenen',
        es: 'Estimar fecha de entrega',
    },
    userGuide: {
        en: 'User guide',
        fr: 'Guide utilisateur',
        nl: 'Gebruikershandleiding',
        es: 'Guía del usuario',
    },
    userGuideDescription: {
        en: 'Discover how to use the site and its features.',
        fr: 'Découvrez comment utiliser le site et ses fonctionnalités.',
        nl: 'Ontdek hoe u de site en functies gebruikt.',
        es: 'Descubra cómo usar el sitio y sus funciones.',
    },
    pickupCode: {
        en: 'Postal code or loading department',
        fr: 'Code postal ou département de chargement',
        nl: 'Postcode of laaddepartement',
        es: 'Código postal o departamento de carga',
    },
    deliveryCode: {
        en: 'Postal code or delivery department',
        fr: 'Code postal ou département de livraison',
        nl: 'Postcode of leveringsdepartement',
        es: 'Código postal o departamento de entrega',
    },
    deliveryDateResult: {
        en: 'Delivery estimated on {{date}}',
        fr: 'Livraison estimée le {{date}}',
        nl: 'Levering geschat op {{date}}',
        es: 'Entrega estimada el {{date}}',
    },
    estimate: {
        en: 'Estimate',
        fr: 'Estimer',
        nl: 'Berekenen',
        es: 'Estimar',
    },
    estimateDeliveryDateTitle: {
        en: 'Estimate the delivery date according to our theoretical planning',
        fr: 'Estimez la date de livraison selon notre planning théorique',
        nl: 'Bereken de leverdatum volgens onze planning',
        es: 'Estime la fecha de entrega según nuestra planificación',
    },
    supplierCodeNo: {
        en: 'Supplier code no',
        fr: 'Numéro de commande fournisseur',
        nl: 'Leverancierscode nr.',
        es: 'N.º de código de proveedor',
    },
    clientCodeNo: {
        en: 'Client code no',
        fr: 'Numéro de commande client',
        nl: 'Klantcode nr.',
        es: 'N.º de código de cliente',
    },
    xmlCode: {
        en: 'XML code',
        fr: 'Code XML',
        nl: 'XML-code',
        es: 'Código XML',
    },
    noDesiredDate: {
        en: 'No desired date',
        fr: 'Pas de date souhaitée',
        nl: 'Geen gewenste datum',
        es: 'Sin fecha deseada',
    },
    active: {
        en: 'Active',
        fr: 'Actif',
        nl: 'Actief',
        es: 'Activo',
    },
    noActive: {
        en: 'Inactive',
        fr: 'Inactif',
        nl: 'Inactief',
        es: 'Inactivo',
    },
    noInstruction: {
        en: 'No instruction',
        fr: "Pas d'instruction",
        nl: 'Geen instructie',
        es: 'Sin instrucciones',
    },
    noRequirement: {
        en: 'No requirement',
        fr: "Pas d'impératif",
        nl: 'Geen vereiste',
        es: 'Sin requisitos',
    },
    noComment: {
        en: 'No comment',
        fr: 'Pas de commentaire',
        nl: 'Geen opmerking',
        es: 'Sin comentarios',
    },
    noLogisticConstraint: {
        en: 'No logistic constraint',
        fr: 'Pas de contrainte logistique',
        nl: 'Geen logistieke beperking',
        es: 'Sin restricciones logísticas',
    },
    noDocument: {
        en: 'No document',
        fr: 'Pas de document',
        nl: 'Geen document',
        es: 'Sin documentos',
    },
    maintenance1: {
        en: 'Order creation is currently not available.',
        fr: "La création de commande n'est actuellement pas disponible.",
        nl: 'Het aanmaken van bestellingen is momenteel niet beschikbaar.',
        es: 'La creación de pedidos no está disponible actualmente.',
    },
    maintenance2: {
        fr: 'Vous pouvez néanmoins consulter vos commandes en cours.',
        en: 'You can nevertheless consult your current orders.',
        nl: 'U kunt wel uw lopende bestellingen inzien.',
        es: 'Sin embargo, puede consultar sus pedidos en curso.',
    },
    maintenance3: {
        fr: 'Vous pouvez également consulter les informations de votre compte.',
        en: 'You can also consult the information of your account.',
        nl: 'U kunt ook uw accountgegevens inzien.',
        es: 'También puede consultar la información de su cuenta.',
    },
    print: {
        en: 'Print',
        fr: 'Imprimer',
        nl: 'Afdrukken',
        es: 'Imprimir',
    },
    printLabels: {
        en: 'Print labels',
        fr: 'Imprimer les étiquettes',
        nl: 'Labels afdrukken',
        es: 'Imprimir etiquetas',
    },
    printLabelsSubtitle: {
        fr: "Choisissez le nombre d'étiquettes que vous voulez imprimer par page.",
        en: 'Choose the number of labels you want to print per page.',
        nl: 'Kies het aantal labels per pagina.',
        es: 'Elija el número de etiquetas que desea imprimir por página.',
    },
    visibleOperatingCenters: {
        en: 'Visible Pickup Platforms',
        fr: 'Plateformes Enlèvement visibles',
        nl: 'Zichtbare ophaalplatforms',
        es: 'Plataformas de recogida visibles',
    },
    pickupType: {
        en: 'Pickup type',
        fr: "Type d'enlèvement",
        nl: 'Ophaaltype',
        es: 'Tipo de recogida',
    },
    dockingPlatform: {
        en: 'Berthing platform',
        fr: 'Plateforme de remise à quai',
        nl: 'Kadeplatform',
        es: 'Plataforma de muelle',
    },
    docksidePickupDate: {
        en: 'Dockside pickup date',
        fr: 'Date de remise à quai',
        nl: 'Datum kade-afhaling',
        es: 'Fecha de recogida en muelle',
    },
    deliveryDateType: {
        fr: 'Délai de livraison',
        en: 'Delivery time',
        nl: 'Levertijd',
        es: 'Plazo de entrega',
    },
    nbOfLabel: {
        en: 'Number of labels',
        fr: "Nombre d'étiquettes",
        nl: 'Aantal labels',
        es: 'Número de etiquetas',
    },
    minDays: {
        fr: "Nb minimum de jours après la date d'enlèvement",
        en: 'Minimum number of days after the pickup date',
        nl: 'Min. aantal dagen na afhaling',
        es: 'N.º mín. de días tras recogida',
    },
    waitingLabelsForValidation: {
        fr: 'Vous pourrez imprimer les étiquettes lorsque votre commande sera validée.',
        en: 'You will be able to print the labels when your order is validated.',
        nl: 'U kunt labels afdrukken zodra uw bestelling is gevalideerd.',
        es: 'Podrá imprimir las etiquetas cuando su pedido esté validado.',
    },
    waitingLabelsForTransport: {
        fr: 'Vous pourrez imprimer les étiquettes lorsque tous les transports auront été générés.',
        en: 'You will be able to print the labels when all transports have been generated.',
        nl: 'U kunt labels afdrukken zodra alle transporten zijn gegenereerd.',
        es: 'Podrá imprimir las etiquetas cuando se hayan generado todos los transportes.',
    },
    printSummary: {
        en: 'Print summary',
        fr: 'Imprimer le récapitulatif',
        nl: 'Overzicht afdrukken',
        es: 'Imprimir resumen',
    },
    myOrderQuotes: {
        en: 'My quotes',
        fr: 'Mes devis',
        nl: 'Mijn offertes',
        es: 'Mis cotizaciones',
    },
    orderQuote: {
        en: 'Quote',
        fr: 'Devis',
        nl: 'Offerte',
        es: 'Cotización',
    },
    orderQuotes: {
        en: 'Quotes',
        fr: 'Devis',
        nl: 'Offertes',
        es: 'Cotizaciones',
    },
    allMyOrderQuotes: {
        en: 'All my quotes',
        fr: 'Tous mes devis',
        nl: 'Al mijn offertes',
        es: 'Todas mis cotizaciones',
    },
    newOrderQuote: {
        en: 'New quote',
        fr: 'Nouveau devis',
        nl: 'Nieuwe offerte',
        es: 'Nueva cotización',
    },
    viewDirectionsButton: {
        en: 'View directions on Google Maps',
        fr: "Voir l'itinéraire sur Google Maps",
        nl: 'Bekijken op Maps',
        es: 'Ver ruta en Google Maps',
    },
    viewAddress: {
        en: 'View address',
        fr: "Voir l'adresse",
        nl: 'Adres bekijken',
        es: 'Ver dirección',
    },
    year: {
        en: 'Year',
        fr: 'Année',
        nl: 'Jaar',
        es: 'Año',
    },
    deleteVacationWeek: {
        en: 'Delete vacation week',
        fr: 'Supprimer la semaine de congés',
        nl: 'Vakantieweek verwijderen',
        es: 'Eliminar semana de vacaciones',
    },
    modalEditVacationWeekTitle: {
        en: 'Edit vacation week',
        fr: 'Modifier la semaine de congés',
        nl: 'Vakantieweek bewerken',
        es: 'Editar semana de vacaciones',
    },
    modalVacationWeekTitle: {
        en: 'New vacation week',
        fr: 'Nouvelle semaine de congés',
        nl: 'Nieuwe vakantieweek',
        es: 'Nueva semana de vacaciones',
    },
    sureDeleteVacationWeek: {
        en: 'Are you sure you want to delete this vacation week? This action is definitive.',
        fr: 'Êtes-vous sûr de vouloir supprimer cette semaine de congés ? Cette action est définitive.',
        nl: 'Weet u zeker dat u deze vakantieweek wilt verwijderen? Deze actie is definitief.',
        es: '¿Está seguro de que desea eliminar esta semana de vacaciones? Esta acción es definitiva.',
    },
    vacationWeeks: {
        en: 'Vacation weeks',
        fr: 'Semaines de congés',
        nl: 'Vakantieweken',
        es: 'Semanas de vacaciones',
    },
    allMyQuotes: {
        en: 'All my quotes',
        fr: 'Tous mes devis',
        nl: 'Al mijn offertes',
        es: 'Todas mis cotizaciones',
    },
    quoteInProgress: {
        fr: 'Chiffrage en cours',
        en: 'Quotation in progress',
        nl: 'Offerte in behandeling',
        es: 'Cotización en curso',
    },
    clientValidation: {
        fr: 'Validation client',
        en: 'Client validation',
        nl: 'Klantvalidatie',
        es: 'Validación de cliente',
    },
    accepted: {
        fr: 'Acceptés',
        en: 'Accepted',
        nl: 'Geaccepteerd',
        es: 'Aceptados',
    },
    Declined: {
        fr: 'Refusés',
        en: 'Refused',
        nl: 'Geweigerd',
        es: 'Rechazados',
    },
    deliveryStartDate: {
        fr: 'Date début livraison',
        en: 'Delivery start date',
        nl: 'Startdatum levering',
        es: 'Fecha de inicio de entrega',
    },
    deliveryEndDate: {
        fr: 'Date fin livraison',
        en: 'Delivery end date',
        nl: 'Einddatum levering',
        es: 'Fecha de fin de entrega',
    },
    requestForQuote: {
        en: 'Request for quote',
        fr: 'Demande de devis',
        nl: 'Offerteaanvraag',
        es: 'Solicitud de cotización',
    },
    quoteStatusCreated: {
        fr: 'Création de devis',
        en: 'Quote in creation',
        nl: 'Offerte in aanmaak',
        es: 'Cotización en creación',
    },
    inQuotation: {
        fr: 'En chiffrage',
        en: 'In quotation',
        nl: 'In calculatie',
        es: 'En cotización',
    },
    quoteStatusClientValidation: {
        fr: 'Validation de devis',
        en: 'Quote validation',
        nl: 'Offertevalidatie',
        es: 'Validación de cotización',
    },
    quoteStatusFinished: {
        fr: 'Terminé',
        en: 'Finished',
        nl: 'Afgehandeld',
        es: 'Finalizado',
    },
    quoteStatusAccepted: {
        fr: 'Devis acceptés',
        en: 'Accepted quotes',
        nl: 'Geaccepteerde offertes',
        es: 'Cotizaciones aceptadas',
    },
    quoteStatusAcceptedSingular: {
        fr: 'Devis accepté',
        en: 'Accepted quote',
        nl: 'Geaccepteerde offerte',
        es: 'Cotización aceptada',
    },
    quoteStatusRefused: {
        fr: 'Devis refusés',
        en: 'Refused quotes',
        nl: 'Geweigerde offertes',
        es: 'Cotizaciones rechazadas',
    },
    quoteStatusRefusedSingular: {
        fr: 'Devis refusé',
        en: 'Refused quote',
        nl: 'Geweigerde offerte',
        es: 'Cotización rechazada',
    },
    confirmOrderQuote: {
        fr: 'Confirmer le devis',
        en: 'Confirm the quote',
        nl: 'De offerte bevestigen',
        es: 'Confirmar la cotización',
    },
    confirmOrderQuoteConfirmation: {
        fr: 'Êtes-vous sûr de vouloir confirmer le devis ?',
        en: 'Are you sure you want to confirm the quote?',
        nl: 'Weet u zeker dat u de offerte wilt bevestigen?',
        es: '¿Está seguro de que desea confirmar la cotización?',
    },
    confirmOrderQuoteWarning: {
        fr: 'Si vous confirmez le devis, vous ne pourrez plus modifier les informations.',
        en: 'If you confirm the quote, you will no longer be able to modify the information.',
        nl: 'Als u de offerte bevestigt, kunt u de informatie niet meer wijzigen.',
        es: 'Si confirma la cotización, no podrá modificar la información.',
    },
    sendCostingOrderQuote: {
        fr: 'Envoyer le chiffrage',
        en: 'Send the costing',
        nl: 'De kostenberekening verzenden',
        es: 'Enviar el presupuesto',
    },
    sendCostingConfirmationOrderQuote: {
        fr: 'Êtes-vous sûr de vouloir envoyer le chiffrage ?',
        en: 'Are you sure you want to send the costing?',
        nl: 'Weet u zeker dat u de kostenberekening wilt verzenden?',
        es: '¿Está seguro de que desea enviar el presupuesto?',
    },
    acceptOrderQuote: {
        fr: 'Accepter le devis',
        en: 'Accept the quote',
        nl: 'De offerte accepteren',
        es: 'Aceptar la cotización',
    },
    acceptOrderQuoteWarning: {
        fr: 'Si vous acceptez le devis, un transport sera créé.',
        en: 'If you accept the quote, a transport will be created.',
        nl: 'Als u de offerte accepteert, wordt er een transport aangemaakt.',
        es: 'Si acepta la cotización, se creará un transporte.',
    },
    acceptOrderQuoteConfirmation: {
        fr: 'Êtes-vous sûr de vouloir accepter le devis ?',
        en: 'Are you sure you want to accept the quote?',
        nl: 'Weet u zeker dat u de offerte wilt accepteren?',
        es: '¿Está seguro de que desea aceptar la cotización?',
    },
    refuseOrderQuote: {
        fr: 'Refuser le devis',
        en: 'Refuse the quote',
        nl: 'De offerte weigeren',
        es: 'Rechazar la cotización',
    },
    refusalReasonRequestOrderQuote: {
        fr: 'Veuillez nous indiquer votre motif de refus.',
        en: 'Please indicate your reason for refusal.',
        nl: 'Gelieve uw reden voor weigering aan te geven.',
        es: 'Por favor, indique su motivo de rechazo.',
    },
    refuseOrderQuoteConfirmation: {
        fr: 'Êtes-vous sûr de vouloir refuser le devis ?',
        en: 'Are you sure you want to refuse the quote?',
        nl: 'Weet u zeker dat u de offerte wilt weigeren?',
        es: '¿Está seguro de que desea rechazar la cotización?',
    },
    counterOfferOrderQuoteConfirmation: {
        fr: 'Êtes-vous sûr de vouloir faire une contre-proposition ?',
        en: 'Are you sure you want to make a counter-offer?',
        nl: 'Weet u zeker dat u een tegenvoorstel wilt doen?',
        es: '¿Está seguro de que desea hacer una contrapropuesta?',
    },
    counterOfferOrderQuoteInfo: {
        fr: 'Si vous faites une contre-proposition, le devis repassera à l’étape de chiffrage.',
        en: 'If you make a counter-offer, the quote will return to the costing step.',
        nl: 'Als u een tegenvoorstel doet, gaat de offerte terug naar de calculatiefase.',
        es: 'Si hace una contrapropuesta, la cotización volverá a la fase de presupuesto.',
    },
    counterOffer: {
        fr: 'Contre-proposition',
        en: 'Counter-offer',
        nl: 'Tegenvoorstel',
        es: 'Contrapropuesta',
    },
    closeOrderQuote: {
        fr: 'Clore le devis',
        en: 'Close the quote',
        nl: 'Offerte afsluiten',
        es: 'Cerrar la cotización',
    },
    closeOrderQuoteInfo: {
        fr: 'Si vous clôturez le devis, il sera terminé.',
        en: 'If you close the quote, it will be finalized.',
        nl: 'Als u de offerte afsluit, wordt deze afgerond.',
        es: 'Si cierra la cotización, se dará por finalizada.',
    },
    orderQuoteNumber: {
        fr: 'Numéro de devis',
        en: 'Quote number',
        nl: 'Offertenummer',
        es: 'Número de cotización',
    },
    closeOrderQuoteConfirmation: {
        fr: 'Êtes-vous sûr de vouloir clore le devis ?',
        en: 'Are you sure you want to close the quote?',
        nl: 'Weet u zeker dat u de offerte wilt afsluiten?',
        es: '¿Está seguro de que desea cerrar la cotización?',
    },
    refusalReasonRequired: {
        fr: 'Le motif de refus est obligatoire',
        en: 'The reason for refusal is required',
        nl: 'De reden van weigering is verplicht',
        es: 'El motivo de rechazo es obligatorio',
    },
    refusalReason: {
        fr: 'Motif de refus',
        en: 'Reason for refusal',
        nl: 'Reden van weigering',
        es: 'Motivo de rechazo',
    },
    confirmAddDocumentMessage: {
        fr: 'Êtes-vous sûr de vouloir ajouter ce document ?',
        en: 'Are you sure you want to add this document?',
        nl: 'Weet u zeker dat u dit document wilt toevoegen?',
        es: '¿Está seguro de que desea añadir este documento?',
    },
    charRemainingOne: {
        fr: '{{count}} caractère restant',
        en: '{{count}} character remaining',
        nl: '{{count}} resterend teken',
        es: '{{count}} carácter restante',
    },
    charRemainingOther: {
        fr: '{{count}} caractères restants',
        en: '{{count}} characters remaining',
        nl: '{{count}} resterende tekens',
        es: '{{count}} caracteres restantes',
    },
    footageMustBeGreaterThanZero: {
        fr: 'Le métrage doit être strictement supérieur à 0',
        en: 'The footage must be strictly greater than 0',
        nl: 'De meterage moet groter zijn dan 0',
        es: 'El metraje debe ser estrictamente superior a 0',
    },
    quoteTotalOutOfRange: {
        fr: 'Le montant total du devis doit être compris entre 1,00 € et 9 999 999,99 €.',
        en: 'The total quote amount must be between €1.00 and €9,999,999.99.',
        nl: 'Het totale offertebedrag moet tussen €1,00 en €9.999.999,99 liggen.',
        es: 'El importe total de la cotización debe estar entre 1,00 € y 9 999 999,99 €.',
    },
    deliveryInvalidFootage: {
        en: 'Either linear meters or length and width are required.',
        fr: 'Le métrage linéaire ou la longueur et la largeur sont obligatoires.',
        nl: 'Strekkende meters of lengte en breedte zijn verplicht.',
        es: 'El metraje lineal o la longitud y la anchura son obligatorios.',
    },
    expirationDateLabel: {
        en: 'Quote expiration date',
        fr: 'Date d’expiration du devis',
        nl: 'Vervaldatum offerte',
        es: 'Fecha de vencimiento de cotización',
    },
    expirationDateDefault: {
        en: 'Default value = D+30',
        fr: 'Valeur par défaut = J+30',
        nl: 'Standaardwaarde = D+30',
        es: 'Valor predeterminado = D+30',
    },
    deleteContact: {
        fr: 'Supprimer le contact',
        en: 'Delete contact',
        nl: 'Contact verwijderen',
        es: 'Eliminar contacto',
    },
    sureDeleteContact: {
        fr: 'Êtes-vous sûr de vouloir supprimer ce contact ?',
        en: 'Are you sure you want to delete this contact?',
        nl: 'Weet u zeker dat u dit contact wilt verwijderen?',
        es: '¿Está seguro de que desea eliminar este contacto?',
    },
    deleteArticle: {
        fr: 'Supprimer la marchandise',
        en: 'Delete article',
        nl: 'Artikel verwijderen',
        es: 'Eliminar artículo',
    },
    sureDeleteArticle: {
        fr: 'Êtes-vous sûr de vouloir supprimer cette marchandise ?',
        en: 'Are you sure you want to delete this article?',
        nl: 'Weet u zeker dat u dit artikel wilt verwijderen?',
        es: '¿Está seguro de que desea eliminar este artículo?',
    },
    quoteExpirationDate: {
        en: 'Quote expiration date',
        fr: "Date d'expiration du devis",
        nl: 'Vervaldatum offerte',
        es: 'Fecha de vencimiento de cotización',
    },

    PleaseFillInThisField: {
        fr: 'Veuillez renseigner ce champ.',
        en: 'Please fill in this field.',
        nl: 'Gelieve dit veld in te vullen.',
        es: 'Por favor, complete este campo.',
    },
    orderLabel: {
        fr: 'Libellé de commande',
        en: 'Order label',
        nl: 'Bestellabel',
        es: 'Etiqueta de pedido',
    },
    cookieConsentTitle: {
        en: 'Cookie management',
        fr: 'Gestion des cookies',
        nl: 'Cookiebeheer',
        es: 'Gestión de cookies',
    },
    cookieConsentDescription: {
        en: 'The cookies used on this website are categorized. Below, you can review each category and choose to allow or reject all or part of them. When categories that were previously authorized are disabled, all cookies assigned to those categories will be removed from your browser. In addition, you can view a list of the cookies assigned to each category and detailed information in the cookie declaration.',
        fr: 'Les cookies utilisés sur le site sont catégorisés et ci-dessous, vous pouvez consulter chaque catégorie et autoriser ou refuser tout ou partie entre elles. Lorsque les catégories qui ont pas été autorisées auparavant sont désactivées, tous les cookies assignés à cette catégorie seront supprimés de votre navigateur. De plus, vous pouvez voir une liste des cookies assignés à chaque catégorie et des informations détaillées dans la déclaration des cookies.',
        nl: 'De cookies die op deze website worden gebruikt, zijn ingedeeld in categorieën. Hieronder kunt u elke categorie bekijken en deze geheel of gedeeltelijk toestaan of weigeren. Wanneer categorieën die eerder waren toegestaan worden uitgeschakeld, worden alle cookies die aan die categorie zijn toegewezen uit uw browser verwijderd. Daarnaast kunt u een lijst bekijken van de cookies die aan elke categorie zijn toegewezen en gedetailleerde informatie raadplegen in de cookieverklaring.',
        es: 'Las cookies utilizadas en este sitio web están clasificadas por categorías. A continuación, puede consultar cada categoría y autorizar o rechazar la totalidad o parte de ellas. Cuando se desactiven categorías que anteriormente habían sido autorizadas, todas las cookies asignadas a esas categorías se eliminarán de su navegador. Además, puede consultar una lista de las cookies asignadas a cada categoría y obtener información detallada en la declaración de cookies.',
    },
    cookieConsentCustomizationDescription: {
        en: 'Choose the services you authorize. Essential cookies always remain active to allow the portal to work properly.',
        fr: 'Choisissez les services que vous autorisez. Les cookies essentiels restent toujours actifs pour permettre le fonctionnement du portail.',
        nl: 'Kies de diensten die u toestaat. Essentiële cookies blijven altijd actief om de goede werking van het portaal mogelijk te maken.',
        es: 'Elija los servicios que autoriza. Las cookies esenciales permanecen siempre activas para permitir el correcto funcionamiento del portal.',
    },
    cookieConsentEssentialTitle: {
        en: 'Essential cookies',
        fr: 'Cookies essentiels',
        nl: 'Essentiële cookies',
        es: 'Cookies esenciales',
    },
    cookieConsentEssentialDescription: {
        en: 'Required for the operation and security of the portal.',
        fr: 'Indispensables au fonctionnement et à la sécurité du portail.',
        nl: 'Noodzakelijk voor de werking en beveiliging van het portaal.',
        es: 'Necesarias para el funcionamiento y la seguridad del portal.',
    },
    cookieConsentGoogleAnalyticsDescription: {
        en: 'Audience measurement to understand portal usage.',
        fr: 'Mesure d\'audience pour comprendre l\'utilisation du portail.',
        nl: 'Publieksmeting om het gebruik van het portaal te begrijpen.',
        es: 'Medición de audiencia para comprender el uso del portal.',
    },
    cookieConsentHotjarDescription: {
        en: 'User experience analysis to improve user journeys.',
        fr: 'Analyse de l\'expérience utilisateur pour améliorer les parcours.',
        nl: 'Analyse van de gebruikerservaring om trajecten te verbeteren.',
        es: 'Análisis de la experiencia de usuario para mejorar los recorridos.',
    },
    cookieConsentCustomize: {
        en: 'Customize',
        fr: 'Personnaliser',
        nl: 'Aanpassen',
        es: 'Personalizar',
    },
    cookieConsentAccept: {
        en: 'Accept',
        fr: 'Accepter',
        nl: 'Accepteren',
        es: 'Aceptar',
    },
    cookieConsentManage: {
        en: 'Manage my cookies',
        fr: 'Gérer mes cookies',
        nl: 'Mijn cookies beheren',
        es: 'Gestionar mis cookies',
    },
    cookieConsentPrivacyPolicy: {
        en: 'Privacy Policy',
        fr: 'Politique de Confidentialité',
        nl: 'Privacybeleid',
        es: 'Política de privacidad',
    },
    image: {
        en: 'Image',
        fr: 'Image',
        nl: 'Afbeelding',
        es: 'Imagen',
    },

    enabledDisabled: {
        en: 'Enabled/Disabled',
        fr: 'Activé/Désactivé',
        nl: 'Ingeschakeld/Uitgeschakeld',
        es: 'Activado/Desactivado',
    },
    enabled: {
        en: 'Enabled',
        fr: 'Activé',
        nl: 'Ingeschakeld',
        es: 'Activado',
    },
    disabled: {
        en: 'Disabled',
        fr: 'Désactivé',
        nl: 'Uitgeschakeld',
        es: 'Desactivado',
    },
    enableUser: {
        en: 'Enable user',
        fr: "Activer l'utilisateur",
        nl: 'Gebruiker inschakelen',
        es: 'Activar usuario',
    },
    disableUser: {
        en: 'Disable user',
        fr: "Désactiver l'utilisateur",
        nl: 'Gebruiker uitschakelen',
        es: 'Desactivar usuario',
    },
    sureEnableUser: {
        en: 'Are you sure you want to enable this user?',
        fr: 'Êtes-vous certain de vouloir activer cet utilisateur ?',
        nl: 'Weet u zeker dat u deze gebruiker wilt inschakelen?',
        es: '¿Está seguro de que desea activar este usuario?',
    },
    sureDisableUser: {
        en: 'Are you sure you want to disable this user?',
        fr: 'Êtes-vous certain de vouloir désactiver cet utilisateur ?',
        nl: 'Weet u zeker dat u deze gebruiker wilt uitschakelen?',
        es: '¿Está seguro de que desea desactivar este usuario?',
    },
    userEnabled: {
        en: 'The user has been enabled.',
        fr: "L'utilisateur a été activé.",
        nl: 'De gebruiker is ingeschakeld.',
        es: 'El usuario ha sido activado.',
    },
    userReactivatedResetEmailSent: {
        en: 'The account has been reactivated and a password reset email has been sent to the client.',
        fr: 'Le compte a été réactivé et un email de réinitialisation du mot de passe a été envoyé au client.',
        nl: 'Het account is opnieuw geactiveerd en er is een e-mail voor het opnieuw instellen van het wachtwoord naar de klant verzonden.',
        es: 'La cuenta se ha reactivado y se ha enviado un correo de restablecimiento de contraseña al cliente.',
    },
    userDisabled: {
        en: 'The user has been disabled.',
        fr: "L'utilisateur a été désactivé.",
        nl: 'De gebruiker is uitgeschakeld.',
        es: 'El usuario ha sido desactivado.',
    },

    lastConnectionDate: {
        en: 'Last connection date',
        fr: 'Date de dernière connexion',
        nl: 'Datum van laatste verbinding',
        es: 'Fecha de la última conexión',
    },

    orderQuoteSettings: {
        en: 'Order quote settings',
        fr: 'Paramètres des devis',
        nl: 'Instellingen voor offertes',
        es: 'Configuración de presupuestos',
    },

    tmsTvaAmount: {
        en: 'VAT rate (TMS)',
        fr: 'Taux de TVA (TMS)',
        nl: 'Btw-tarief (TMS)',
        es: 'Tipo de IVA (TMS)',
    },
}
